<template>
    <div class="row">
        <div class="col-md-12 d-flex align-items-center mb-1" v-if="selectedFilterDate!=''">
            <div
                class="bg-theme px-3 py-2 text-white rounded-5 d-flex justify-content-between"
                :style="{
                    minWidth: ['custom_day', 'today', 'tomorrow'].includes(selectedFilterDate) ? '210px' : '340px'
                }"
            >
                <!-- Next/Previous button -->
                <div class="d-flex gap-2">
                    <div v-if="selectedFilterDate!=''" class="cursor-pointer" @click="getPreviousData">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-arrow-left-icon lucide-square-arrow-left"><rect width="18" height="18" x="3" y="3" rx="2"></rect><path d="m12 8-4 4 4 4"></path><path d="M16 12H8"></path></svg>
                    </div>
                    <div v-if="selectedFilterDate!=''" class="cursor-pointer" @click="getNextData">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-arrow-right-icon lucide-square-arrow-right"><rect width="18" height="18" x="3" y="3" rx="2"></rect><path d="M8 12h8"></path><path d="m12 16 4-4-4-4"></path></svg>
                    </div>
                </div>
                <div class="hm-fs-18 ms-2">
                    <template v-if="daysOptions.includes(selectedFilterDate)">
                        {{ formattedDate(currentDate, 'DD MMM YYYY').toUpperCase() }}
                    </template>
                    <template v-else-if="weekOptions.includes(selectedFilterDate)">
                        {{ formattedDate(startOfWeek, 'DD MMM YYYY').toUpperCase() }} - {{ formattedDate(endOfWeek, 'DD MMM YYYY').toUpperCase() }}
                    </template>
                    <template v-else-if="monthOptions.includes(selectedFilterDate)">
                        {{ formattedDate(currentMonth, 'MMM YYYY').toUpperCase() }}
                    </template>
                </div>
            </div>
        </div>
        <div class="col-md-6 d-flex align-items-center gap-2 flex-wrap mb-1">
            <button
                type="button"
                class="btn btn-sm btn-outline-theme"
                v-text="displayMapOrList==='map' ? 'View List' : 'View Map'"
                @click="displayMapOrList=displayMapOrList==='map' ? 'list' : 'map'"
            ></button>
            <button v-if="!isLoading" type="button" class="btn btn-sm btn-outline-theme d-flex" @click="getOrders">
                <i class="bi bi-arrow-clockwise d-none d-md-block d-lg-block d-xl-block me-1"></i> Refresh
            </button>
            <button v-else type="button" class="btn btn-sm btn-outline-theme disabled d-flex" disabled>
                <span class="spinner-border spinner-border-sm d-none d-md-block d-lg-block d-xl-block me-1" role="status" aria-hidden="true"></span>
                Loading...
            </button>
            <button type="button" class="btn btn-sm btn-outline-theme d-flex" @click="openCreateOrderWindow">
                <i class="bi bi-plus d-none d-md-block d-lg-block d-xl-block me-1"></i> Create Order
            </button>

            <!-- Download report -->
            <button type="button" class="btn btn-sm btn-outline-theme d-flex" data-bs-toggle="modal" data-bs-target="#downloadReportModal">
                <i class="bi bi-arrow-down-circle pe-1 d-none d-md-block d-lg-block d-xl-block me-1"></i>Reports
            </button>
        </div>
        <div class="col-md-6 d-flex justify-content-md-end align-items-center gap-2 mb-1">
            <div class="pe-0">
                <input
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Search Order"
                    v-model="searchOrder"
                >
            </div>
            <!-- <div class="col-auto pe-0">
                <button
                    type="button"
                    class="btn btn-sm"
                    :class="[selectedFilterDate === 'today' ? 'btn-theme' : 'btn-outline-theme']"
                    @click="selectedFilterDate='today'"
                >Today</button>
            </div>
            <div class="col-auto pe-0">
                <button
                    type="button"
                    class="btn btn-sm"
                    :class="[selectedFilterDate === 'tomorrow' ? 'btn-theme' : 'btn-outline-theme']"
                    @click="selectedFilterDate='tomorrow'"
                >Tomorrow</button>
            </div> -->
            <div class="col-auto pe-0 hm-db--date-filter">
                <select v-model="selectedFilterDate" class="form-select form-select-sm">
                    <option value="">Filter Order</option>
                    <option value="today">Today</option>
                    <option value="tomorrow">Tomorrow</option>
                    <option value="this_week">This Week</option>
                    <option value="next_week">Next Week</option>
                    <option value="this_month">This Month</option>
                </select>
                <!-- <VueSelect
                    v-model="selectedFilterDate"
                    :items="[
                        {id: ' ', text: 'Filter Order', name: 'Filter Order'},
                        {id: 'this_week', text: 'This Week', name: 'This Week'},
                        {id: 'next_week', text: 'Next Week', name: 'Next Week'},
                        {id: 'this_month', text: 'This Month', name: 'This Month'},
                    ]"
                    :placeholder="'Filter Order'"
                    :searchable="false"
                ></VueSelect> -->
            </div>
            <button type="button" class="btn btn-sm btn-outline-danger" @click="resetOrderFilter">Reset</button>
        </div>
    </div>
    <!--Display map-->
    <div v-show="displayMapOrList=='map'" class="row">
        <div class="col">
            <google-map :orders="mapOrders"></google-map>
        </div>
    </div>
    <div
        v-show="displayMapOrList=='list'"
        class="overflow-auto order-list-container"
        :style="{ maxHeight: screenHeight + 'px' }"
    >
        <div class="row">
            <div class="col">
                <div class="d-inline-flex grid gap-0 column-gap-3">
                    <div
                        v-for="orderType in orderTypes"
                        class="order-status-column d-inline gap-1"
                    >
                        <div class="card mb-1 rounded-0 sticky-top">
                            <div class="card-header border-0 d-flex justify-content-between align-items-center p-2">
                                <h6 class="p-0 m-0 position-relative">
                                    <i
                                        class="ri-circle-fill position-absolute order-status-dot"
                                        :class="orderType.type + '-bg'"
                                    ></i>
                                    <span class="ms-3">{{ orderType.text }}</span>
                                </h6>
                                <span>({{ orders[orderType.type]?.length ?? 0 }}
                                    {{ orders[orderType.type]?.length === 1 ? "Order" : "Orders" }})
                                </span>
                            </div>
                        </div>

                        <!-- List the orders -->
                        <div class="order-item-container">
                            <!-- Loading indicator for each order type -->
                            <div 
                                v-if="isOrderTypeLoading(orderType.type)" 
                                class="d-flex justify-content-center align-items-center p-4"
                                style="min-height: 200px;"
                            >
                                <div class="spinner-border text-primary" role="status">
                                    <span class="visually-hidden">Loading {{ orderType.text }}...</span>
                                </div>
                            </div>
                            <draggable
                                v-else
                                class="order-list-group min-vh-100"
                                :class="orderType.type"
                                :data-status="orderType.type"
                                v-model="orders[orderType.type]"
                                v-bind="dragOptions"
                                group="people"
                                :item-key="orderType.type"
                                :component-data="{ status: orderType.type }"
                                :disabled="isMobile"
                                @start="startDrag"
                                :move="onMove"
                                @end="endDrag"
                                @change="onChangeItem"
                            >
                                <template #item="{ element }">
                                    <div
                                        @contextmenu.prevent.stop="orderItemClick($event, element)"
                                        @touchstart="handleTouchStart($event, element)"
                                        @touchend="handleTouchEnd"
                                        @touchmove="handleTouchMove"
                                        class="card mb-2 rounded-0 order-list-group-item task-bg-purple"
                                        :class="[
                                            'order-priority-' + element.priority + (element.order_histories.length > 0 && element.status =='pending' ? ' quation_approved' : ''),
                                            {'temporary-order': isProvisionalOrder(element)},
                                            {'order-priority-low': element.is_recurring_order}
                                        ]"
                                    >
                                        <div class="card-body p-2 pt-0 pb-0 position-relative">
                                            <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-theme text-capitalize">
                                                {{ element.is_recurring_order ? 'Due' :  element.priority}}
                                            </span>
                                            <div class="d-flex justify-content-between">
                                                <ul class="mb-0 mt-0 p-0 flex-grow-1">
                                                    <li class="list-group-item d-flex justify-content-between align-items-start pb-2">
                                                        <div class="d-flex flex-column gap-2 flex-grow-1">
                                                            <label>{{truncateString(element.full_name, 22)}}</label>
                                                            <!-- <label>{{element.contact_person_full_name}}</label> -->
                                                            <label>{{truncateString(element.address,22)}}</label>
                                                            <!-- Display first order items service_name -->
                                                            <label class="d-inline-block text-truncate" style="width: 150px;">{{element?.order_items[0]?.service_name}}</label>
                                                            <div>
                                                                <label v-if="element.status==='engineer_completed' && element?.data?.revisit_or_complete==='revisit_required'" class="badge bg-danger text-wrap">Revisit Required</label>
                                                                <label v-else-if="element.status==='engineer_completed' && element?.data?.revisit_or_complete==='complete'" class="badge bg-success text-wrap me-1">Work Completed</label>
                                                                <!-- <template v-else-if="element.is_approved === 0 && element.order_type === 'temporary'">
                                                                    <label class="badge bg-danger text-wrap">Temporary</label>
                                                                    <label class="badge bg-danger text-wrap ms-2 cursor-pointer" @click="approveTemporaryOrder(element)">Approve</label>
                                                                </template>
                                                                <template v-else> -->
                                                                    <label class="badge bg-theme text-wrap">
                                                                        {{
                                                                            element.order_handymans
                                                                                .filter(handyman => handyman?.handyman !== null)
                                                                                .map(handyman => handyman?.handyman?.roles?.some(role => role?.name === 'provider') ? 'Admin' : formatName(handyman?.handyman?.name)).join(', ')
                                                                        }}
                                                                    </label>
                                                                    <label v-if="element.is_approved === 1 && element.order_type === 'temporary'" class="badge bg-success text-wrap ms-2">Approved</label>
                                                                    <label
                                                                        v-else-if="isProvisionalOrder(element)"
                                                                        class="badge bg-warning text-wrap ms-2 cursor-pointer text-black"
                                                                        @click="approveTemporaryOrder(element)"
                                                                    >Pending</label>
                                                                <!-- </template> -->
                                                            </div>
                                                        </div>
                                                    <!--  <span
                                                            class="badge rounded-0 text-capitalize order-status-badge me-1"
                                                            :class="orderType.type + '-bg'"
                                                        >
                                                            {{ element.priority == 'low' ? 'Due' :  element.priority}}
                                                        </span> -->
                                                        <div class="d-flex flex-column align-items-end gap-2 text-end">
                                                            <label class="text-truncate" >{{formatDate(element.booking_date,"DD-MMM-YYYY")}}</label>
                                                            <label>{{element.postal_code}}</label>
                                                            <label>{{element.status !="pending"? "£" + element.final_amount.toFixed(2): ""}}</label>
                                                            <!-- Display booking time in 12 hour format -->
                                                            <label class="text-nowrap">
                                                                {{dataTimeFormatWithoutUTC(element.booking_date,"hh:mm A")}} - {{dataTimeFormatWithoutUTC(momentWithoutUTC(element.booking_date).add(element.assigned_order_duration, 'hours'),"hh:mm A")}}
                                                            </label>
                                                        </div>
                                                    </li>
                                                    <!-- <li
                                                        class="list-group-item"
                                                        :class="{'d-flex justify-content-between' : orderType.type === 'completed'}"
                                                    >
                                                        <a v-if="orderType.type === 'completed'" :href="'/admin/invoice/download/' + element.order_number" class="btn btn-sm btn-theme">
                                                            <i class="bi bi-printer"></i>
                                                        </a>
                                                        <a
                                                            class="btn btn-sm btn-theme float-end"
                                                            :href="
                                                                '/admin/orders/' +
                                                                element.order_number
                                                            "
                                                            target="_blank"
                                                            ><i
                                                                class="bi bi-eye"
                                                            ></i
                                                        ></a>
                                                        <button type="button" class="btn btn-sm btn-theme" @click="viewOrderDetail(element)"><i class="bi bi-eye"></i></button>
                                                    </li>  -->
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </draggable>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- right click context -->
        <vue-simple-context-menu
            element-id="myFirstMenu"
            :options="orderOptions"
            ref="orderItemContext"
            @option-clicked="orderItemMenuAction"
        >
        </vue-simple-context-menu>

        <!-- Confirmation Modal for Moving Order Backward -->
        <div
            class="modal fade"
            id="confirmBackwardMoveModal"
            tabindex="-1"
            aria-labelledby="backwardMoveModalLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="backwardMoveModalLabel">
                            Confirm Status Change
                        </h5>
                        <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div class="modal-body">
                        <p>
                            Are you sure about changing the status to
                            <strong>{{ moveToStatus }}</strong
                            >?
                        </p>
                        <div class="mb-3">
                            <label for="reasonInput" class="form-label"
                                >Reason for Change</label
                            >
                            <textarea
                                class="form-control"
                                id="reasonInput"
                                v-model="backwardReason"
                            ></textarea>
                            <div class="text-danger mt-2">
                                {{ errors["backwardReason"] || "" }}
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            @click="cancelItemDrop"
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            class="btn btn-primary"
                            @click="submitBackwardMove"
                        >
                            Confirm
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Assign order to handyman modal dialog -->
        <div
            class="modal fade"
            id="assignOrderModal"
            tabindex="-1"
            data-backdrop="static"
            data-keyboard="false"
        >
            <div class="modal-dialog modal-lg">
                <div class="modal-content bg-white">
                    <!-- First check if order is temporary and not approved -->
                    <!-- <template v-if="updateOrderData.order.is_approved === 0 && updateOrderData.order.order_type === 'temporary'">
                        <div class="modal-header">
                            <h5 class="modal-title">Approve Order</h5>
                        </div>
                        <div class="modal-body">
                            <p class="text-center">Are you sure about approving this order?</p>
                            <div class="d-flex justify-content-center">
                                <button class="btn btn-danger btn-sm" @click="cancelItemDrop">Cancel</button>
                                <button class="btn btn-theme btn-sm ms-2" @click="approveTemporaryOrder(updateOrderData.order)">Approve</button>
                            </div>
                        </div>
                    </template> -->
                    <template v-if="!enggDocReady">
                        <div class="modal-header">
                            <h5 class="modal-title">Engineer Document Ready?</h5>
                        </div>
                        <div class="modal-body">
                            <div class="row mb-4">
                                <div class="col-md-12 text-center text-black">
                                    <p>Verify the order status before proceeding.</p>
                                </div>
                                <div class="col-md-12 d-flex justify-content-center gap-2">
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" type="radio" id="flexRadioDefault1" v-model="updateOrderData.order_type" value="regular">
                                        <label class="form-check-label" for="flexRadioDefault1">Confirmed Order</label>
                                    </div>
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" type="radio" id="flexRadioDefault2" v-model="updateOrderData.order_type" value="temporary">
                                        <label class="form-check-label" for="flexRadioDefault2">Provisional Order</label>
                                    </div>
                                </div>
                            </div>
                            <p class="text-center text-black">Engineer Document Ready?</p>
                            <div class="d-flex justify-content-center">
                                <button class="btn btn-danger btn-sm" @click="cancelItemDrop">No, Cancel</button>
                                <button class="btn btn-theme btn-sm ms-2" @click="enggDocReady = true">Yes, Ready</button>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="modal-header">
                            <h5 class="modal-title">Task Assign To</h5>
                            <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
                        </div>
                        <div class="modal-body">
                            <form class="row g-3">
                                <div class="col-md-4">
                                    <label for="customer_name" class="form-label">Client Name</label>
                                    <input
                                        type="text"
                                        class="form-control disabled"
                                        id="customer_name"
                                        disabled
                                        v-model="updateOrderData.order.full_name"
                                    />
                                </div>
                                <div class="col-md-4">
                                    <label for="order_id" class="form-label">Order ID</label>
                                    <input
                                        type="text"
                                        class="form-control disabled"
                                        id="order_id"
                                        disabled
                                        v-model="updateOrderData.order.order_number"
                                    />
                                </div>
                                <div class="col-md-4">
                                    <label for="phone_number" class="form-label">Mobile Number</label>
                                    <input
                                        type="text"
                                        class="form-control disabled"
                                        id="phone_number"
                                        disabled
                                        v-model="updateOrderData.order.phone_number"
                                    />
                                </div>
                                <div class="col-md-4">
                                    <label for="email" class="form-label">Email</label>
                                    <input
                                        type="text"
                                        class="form-control disabled"
                                        id="email"
                                        disabled
                                        v-model="updateOrderData.order.email"
                                    />
                                </div>
                                <div class="col-md-8">
                                    <label for="email" class="form-label">Address</label>
                                    <textarea
                                        class="form-control disabled"
                                        id="email"
                                        rows="1"
                                        disabled
                                        v-model="updateOrderData.order.booking_address"
                                    ></textarea>
                                </div>
                                <hr class="mb-0"/>
                                <div class="col-md-4">
                                    <label for="assign_date" class="form-label">Assign Date <span class="text-danger">*</span></label>
                                    <BookingDatePicker
                                        v-model="updateOrderData.order_booking_date"
                                        :format="'dd-MM-yyyy'"
                                        :time-picker="false"
                                        :auto-apply="true"
                                    />
                                </div>
                                <div class="col-md-4">
                                    <label for="assign_date" class="form-label">Assign Time <span class="text-danger">*</span></label>
                                    <!-- <VueDatePicker
                                        v-model="updateOrderData.order_booking_time"
                                        time-picker :is-24="false"
                                        :clearable="false"
                                        :minutes-grid-increment="10"
                                        :minutes-increment="15"
                                    >
                                        <template #input-icon>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clock-11 hm-time-icons"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 9.5 8"/></svg>
                                        </template>
                                    </VueDatePicker> -->
                                    <TimePicker v-model="updateOrderData.order_booking_time" placeholder="Select Time" />
                                </div>
                                <div class="col-md-4">
                                    <label for="assign_handyman" class="form-label">Task Assign To <span class="text-danger">*</span></label>
                                    <VueSelect
                                        v-model="updateOrderData.handyman_id"
                                        :items="handymanList"
                                        :multiple="true"
                                        :placeholder="'Select Handyman'"
                                        @onSelectOption="onSelectHandyman"
                                    ></VueSelect>
                                    <small v-if="handymanList.length === 0" class="text-danger">Please select valid assign date and time for task.</small>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-check form-check-inline pb-1">
                                        <input
                                            class="form-check-input"
                                            type="radio"
                                            name="assign_duration"
                                            id="hours"
                                            value="hours"
                                            v-model="updateOrderData.assigned_duration_type"
                                        >
                                        <label class="form-check-label" for="hours">Time Duration (In Hours)</label>
                                    </div>
                                    <div class="form-check form-check-inline pb-1">
                                        <input
                                            class="form-check-input"
                                            type="radio"
                                            name="assign_duration"
                                            id="full_day"
                                            value="full_day"
                                            v-model="updateOrderData.assigned_duration_type"
                                        >
                                        <label class="form-check-label" for="full_day">Full Day</label>
                                    </div>
                                    <input
                                        type="number"
                                        class="form-control"
                                        id="assign_duration"
                                        :class="{'disabled': updateOrderData.assigned_duration_type === 'full_day'}"
                                        :disabled="updateOrderData.assigned_duration_type === 'full_day'"
                                        v-model="updateOrderData.assigned_duration"
                                    />
                                </div>

                                <div class="col-md-6">
                                    <label for="description" class="form-label">Comment</label>
                                    <textarea
                                        class="form-control"
                                        id="description"
                                        rows="1"
                                        v-model="updateOrderData.comment"
                                    ></textarea>
                                </div>

                                <div class="col-md-12">
                                    <label for="description" class="form-label">Attachment</label>
                                    <ImageUploader ref="assignOrderImageUploader" :orderId="updateOrderData.id" />
                                    <!-- <div class="input-group mb-3">
                                        <input
                                            type="file"
                                            class="form-control"
                                            multiple
                                            @change="onFileChange"
                                        />
                                    </div>

                                    <img
                                        v-for="previewImage in previewOrderImages"
                                        :src="previewImage"
                                        class="img-thumbnail me-2 mb-2"
                                        style="{max-height: 150px;max-width: 150px;}"
                                        :key="previewImage"
                                    /> -->
                                </div>
                            </form>
                        </div>
                        <div class="modal-footer">
                            <a
                                type="button"
                                class="text-theme pe-3"
                                data-bs-dismiss="modal"
                                @click="cancelItemDrop"
                            >Cancel</a>
                            <button
                                type="button"
                                class="btn btn-theme btn-sm"
                                v-text="isLoading ? 'Loading...' : 'Save Task'"
                                @click="assignOrder('assign')"
                            ></button>
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <!-- Create or update order quotation modal -->
        <div class="modal fade" id="createOrUpdateQuotation" tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content bg-white">
                    <template v-if="!docRecieved">
                        <div class="modal-header">
                            <h5 class="modal-title">Document Received?</h5>
                        </div>
                        <div class="modal-body">
                            <p class="text-center">Document Received?</p>
                            <div class="d-flex justify-content-center">
                                <button class="btn btn-danger" @click="cancelItemDrop">No, Cancel</button>
                                <button class="btn btn-theme ms-2" @click="docRecieved = true">Yes, Ready</button>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="modal-header">
                            <h5 class="modal-title d-flex justify-content-between">Quotation</h5>
                            <!-- <button
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button> -->
                        </div>
                        <div class="modal-body">
                            <form class="">
                                <!-- First display existing services -->
                                <div
                                    class="row mb-3"
                                    v-if="Object.keys(quotationService.items).length > 0"
                                    v-for="(item, index) in quotationService.items"
                                >
                                    <!-- <div class="col-md-2">
                                        <template v-if="index === 0">
                                            <label for="customer_name" class="form-label">Service Type</label>
                                        </template>
                                        <Select2
                                            v-model="quotationService.items[index].item_type"
                                            :options="serviceTypes"
                                            :settings="{
                                                placeholder: 'Service Type',
                                                selectionCssClass: 'test',
                                                dropdownCssClass:'popup-select2-dropdown',
                                            }"
                                            :class="{'is-invalid':quotationService.items[index].item_type === ''}"
                                        />
                                    </div> -->
                                    <div class="col-md-5">
                                        <template v-if="index === 0">
                                            <label for="customer_name" class="form-label">Service Name</label>
                                        </template>
                                        <!-- <template v-if="quotationService.items[index].item_type === 'service'">
                                            <Select2
                                                v-model="quotationService.items[index].service_id"
                                                :options="serviceOptions"
                                                :settings="{
                                                    placeholder:'Select Service',
                                                    selectionCssClass: 'test',
                                                    dropdownCssClass:'popup-select2-dropdown'
                                                }"
                                                @select="calculateServiceItemAmount('service',index)"
                                                :class="{'is-invalid': quotationService.items[index].service_id === ''}"
                                            />
                                        </template>
                                        <template v-else-if="quotationService.items[index].item_type === 'package'">
                                            <Select2
                                                v-model="quotationService.items[index].package_id"
                                                :options="packageOptions"
                                                :settings="{placeholder:'Select Package'}"
                                                @select="calculateServiceItemAmount('package',index)"
                                                :class="{'is-invalid':quotationService.items[index].package_id === ''}"
                                            />
                                        </template>
                                        <template v-else>
                                            <Select2
                                                :options="[{id: ' ',text: 'Select Service'}]"
                                                :settings="{placeholder:'Select Service'}"
                                                :class="{'is-invalid':quotationService.items[index].service_id === ''}"
                                            />
                                        </template> -->
                                        <!-- <SelectService
                                            v-model="quotationService.items[index].service_id"
                                            :services="serviceOptions"
                                            :taggable="true"
                                            @updateServiceName="quotationService.items[index].service_name = $event; calculateServiceItemAmount('service',index)"
                                        /> -->
                                        <VueSelect
                                            v-model="quotationService.items[index].service_id"
                                            :items="serviceOptions"
                                            :taggable="grue"
                                            @updateLabel="quotationService.items[index].service_name = $event; calculateServiceItemAmount('service',index)"
                                        ></VueSelect>
                                    </div>
                                    <div class="col-md-2 item-fields-number">
                                        <template v-if="index === 0">
                                            <label for="item_price" class="form-label">Item Cost</label>
                                        </template>
                                        <input
                                            type="number"
                                            class="form-control"
                                            id="item_price"
                                            v-model="quotationService.items[index].order_item_price"
                                        />
                                    </div>
                                    <div class="col-md-2 item-fields-number">
                                        <template v-if="index === 0">
                                            <label for="labour_cost"class="form-label">Labour Cost</label>
                                        </template>
                                        <input
                                            type="number"
                                            class="form-control"
                                            id="labour_cost"
                                            v-model="quotationService.items[index].order_item_labour_cost"
                                        />
                                    </div>
                                    <div class="col-md-2 item-fields-number">
                                        <template v-if="index === 0">
                                            <label for="discount" class="form-label">Discount(%)</label>
                                        </template>
                                        <input
                                            type="number"
                                            class="form-control"
                                            id="order_item_discount_value"
                                            v-model="quotationService.items[index].order_item_discount_value"
                                            @input="validateInput('service', index)"
                                        />
                                    </div>
                                    <div class="col-md-1 text-nowrap ps-0">
                                        <template v-if="index === 0">
                                            <div class="pt-4 mt-2"></div>
                                        </template>
                                        <button
                                            v-if="Object.keys(quotationService.items).length > 1 && quotationService.items[index].recurring_services != '1'"
                                            type="button"
                                            class="btn btn-sm btn-danger"
                                            @click="removeOrderItem(index)"
                                            style="left: 30px"
                                        >
                                            <i class="bi bi-trash"></i>
                                        </button>
                                        <button
                                            v-if="Object.keys(quotationService.items).length -1 === index"
                                            type="button"
                                            class="btn btn-sm btn-theme ms-1"
                                            @click="addMoreServiceItem"
                                        >
                                            <i class="bi bi-plus-circle"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <label for="description" class="form-label">Comment</label>
                                                <textarea
                                                    class="form-control"
                                                    id="description"
                                                    rows="4"
                                                    v-model="quotationService.comment"
                                                ></textarea>
                                            </div>
                                        </div>
                                        <!-- <div class="col-md-12">
                                            <label for="description" class="form-label">Attachment</label>
                                            <div class="input-group mb-3">
                                                <input
                                                    type="file"
                                                    class="form-control"
                                                    multiple
                                                    @change="onFileChange"
                                                />
                                            </div>
                                            <img
                                                v-for="previewImage in previewOrderImages"
                                                :src="previewImage"
                                                class="img-thumbnail me-2 mb-2"
                                                style="{max-height: 150px; max-width: 150px;}"
                                                :key="previewImage"
                                            />
                                        </div> -->
                                    </div>
                                    <div class="col-md-6">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <label for="discount" class="form-label">Total Amount</label>
                                                <input
                                                    readonly
                                                    type="number"
                                                    class="form-control"
                                                    id="order_item_discount_value"
                                                    v-model="updateOrderData.total_amount"
                                                />
                                            </div>
                                            <div class="col-md-6">
                                                <label for="discount" class="form-label">Discount(%)</label>
                                                <input
                                                    type="number"
                                                    class="form-control"
                                                    id="order_item_discount_value"
                                                    v-model="updateOrderData.order.discount_value"
                                                />
                                            </div>
                                            <div class="col-md-6">
                                                <label for="discount" class="form-label">VAT(%)</label>
                                                <!-- <Select2
                                                    v-model="updateOrderData.order.tax"
                                                    :options="[
                                                        { id: '0', text: '0' },
                                                        { id: tax, text: tax },
                                                    ]"
                                                    :settings="{minimumResultsForSearch:'Infinity',placeholder: 'Select VAT'}"
                                                /> -->
                                                <VueSelect
                                                    v-model="updateOrderData.order.tax"
                                                    :items="[
                                                        { id: '0', text: '0' },
                                                        { id: tax, text: tax },
                                                    ]"
                                                    :placeholder="'Select VAT'"
                                                    :searchable="false"
                                                ></VueSelect>
                                            </div>
                                            <div class="col-md-6">
                                                <label for="discount" class="form-label">Net Amount</label>
                                                <input
                                                    readonly
                                                    type="number"
                                                    class="form-control"
                                                    id="order_item_discount_value"
                                                    v-model="updateOrderData.final_amount"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <label for="description" class="form-label">Attachment</label>
                                        <ImageUploader ref="quotationImageUploader" :orderId="updateOrderData.id" />
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="modal-footer">
                            <a type="button" class="text-theme pe-3" @click="cancelItemDrop">Cancel</a>
                            <button
                                type="button"
                                class="btn btn-theme btn-sm"
                                v-text="isLoading ? 'Loading...' : 'Save Quotation'"
                                @click="saveQuotation"
                            ></button>
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <!-- Move order to completed -->
        <div class="modal fade" id="updateOrderData" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
            <div class="modal-dialog modal-xl">
                <div class="modal-content bg-white">
                    <div class="modal-header">
                        <h5 class="modal-title">Update Order Amount</h5>
                        <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            @click="cancelItemDrop"
                        ></button>
                    </div>
                    <div class="modal-body">
                        <form class="row g-3">
                            <!-- First display existing services -->
                            <div
                                class="row mb-3"
                                v-if="Object.keys(quotationService.items).length > 0"
                                v-for="(item, index) in quotationService.items"
                            >
                                <div class="col-md-6">
                                    <template v-if="index === 0">
                                        <label for="customer_name" class="form-label">Service Name</label>
                                    </template>
                                    <!-- <template v-if="quotationService.items[index].item_type === 'service'">
                                        <Select2
                                            v-model="quotationService.items[index].service_id"
                                            :options="serviceOptions"
                                            :settings="{
                                                placeholder: 'Select Service',
                                                selectionCssClass: 'test',
                                                dropdownCssClass:'popup-select2-dropdown',
                                            }"
                                            @select="calculateServiceItemAmount('service',index)"
                                            :class="{'is-invalid':quotationService.items[index].service_id === ''}"
                                        />
                                    </template>
                                    <template v-else-if="quotationService.items[index].item_type === 'package'">
                                        <Select2
                                            v-model="quotationService.items[index].package_id"
                                            :options="packageOptions"
                                            :settings="{placeholder: 'Select Package'}"
                                            @select="calculateServiceItemAmount('package',index)"
                                            :class="{'is-invalid':quotationService.items[index].package_id === ''}"
                                        />
                                    </template>
                                    <template v-else>
                                        <Select2
                                            :options="[{id: ' ',text: 'Select Service'}]"
                                            :settings="{placeholder: 'Select Service'}"
                                            :class="{'is-invalid':quotationService.items[index].service_id === ''}"
                                        />
                                    </template> -->
                                    <!-- <SelectService
                                        v-model="quotationService.items[index].service_id"
                                        :services="serviceOptions"
                                        :taggable="true"
                                        @updateServiceName="quotationService.items[index].service_name = $event; calculateServiceItemAmount('service',index)"
                                    /> -->
                                    <VueSelect
                                        :key="index"
                                        v-model="quotationService.items[index].service_id"
                                        :items="serviceOptions"
                                        :taggable="true"
                                        @updateLabel="quotationService.items[index].service_name = $event; calculateServiceItemAmount('service',index)"
                                    />
                                </div>
                                <div class="col-md-2 item-fields-number">
                                    <template v-if="index === 0">
                                        <label for="item_price" class="form-label">Item Cost</label>
                                    </template>
                                    <input
                                        type="number"
                                        class="form-control"
                                        id="item_price"
                                        v-model="quotationService.items[index].order_item_price"
                                    />
                                </div>
                                <div class="col-md-2 item-fields-number">
                                    <template v-if="index === 0">
                                        <label for="labour_cost" class="form-label">Labour Cost</label>
                                    </template>
                                    <input
                                        type="number"
                                        class="form-control"
                                        id="labour_cost"
                                        v-model="quotationService.items[index].order_item_labour_cost"
                                    />
                                </div>
                                <div class="col-md-2 item-fields-number">
                                    <template v-if="index === 0">
                                        <label for="discount" class="form-label">Discount(%)</label>
                                    </template>
                                    <div class="d-flex justify-content-between align-items-center gap-2">
                                        <div>
                                            <input
                                                type="number"
                                                class="form-control"
                                                id="order_item_discount_value"
                                                v-model="quotationService.items[index].order_item_discount_value"
                                                @input="validateInput('service', index)"
                                            />
                                        </div>

                                        <div class="d-flex align-items-center gap-2">
                                            <button
                                                v-if="Object.keys(quotationService.items).length > 1 && quotationService.items[index].recurring_services != '1'"
                                                type="button"
                                                class="btn btn-sm btn-danger"
                                                @click="removeOrderItem(index)"
                                            >
                                                <i class="bi bi-trash"></i>
                                            </button>
                                            <button
                                                v-if="Object.keys(quotationService.items).length -1 === index"
                                                type="button"
                                                class="btn btn-sm btn-theme"
                                                @click="addMoreServiceItem"
                                            >
                                                <i class="bi bi-plus-circle"></i>
                                            </button>
                                        </div>
                                    </div>
                                    
                                </div>
                                <div class="col-md-1 text-nowrap ps-0 d-none">
                                    <template v-if="index === 0">
                                        <div class="pt-4 mt-2"></div>
                                    </template>
                                    <button
                                        v-if="Object.keys(quotationService.items).length > 1 && quotationService.items[index].recurring_services != '1'"
                                        type="button"
                                        class="btn btn-sm btn-danger"
                                        @click="removeOrderItem(index)"
                                        style="left: 30px"
                                    >
                                        <i class="bi bi-trash"></i>
                                    </button>
                                    <button
                                        v-if="Object.keys(quotationService.items).length -1 === index"
                                        type="button"
                                        class="btn btn-sm btn-theme ms-1"
                                        @click="addMoreServiceItem"
                                    >
                                        <i class="bi bi-plus-circle"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label for="invoice_number" class="form-label">Invoice Number</label>
                                        <input
                                            type="number"
                                            class="form-control"
                                            id="invoice_number"
                                            placeholder="Enter Invoice Number"
                                            v-model="updateOrderData.invoice_number"
                                            :class="{ 'is-invalid': updateOrderData.invoice_number==='' && updateOrderData.submit_form }"
                                        />
                                        <div class="is-invalid invalid-feedback">This field is required.</div>
                                    </div>
                                    <div class="col-md-3">
                                        <label for="invoice_date" class="form-label">Invoice Date</label>
                                        <BookingDatePicker
                                            v-model="updateOrderData.invoice_date"
                                            :format="'dd-MM-yyyy'"
                                            :time-picker="false"
                                            :display-marker="false"
                                        />
                                    </div>
                                    <div class="col-md-3">
                                        <label for="invoice_due_at" class="form-label">Invoice Due at</label>
                                        <VueSelect
                                            v-model="updateOrderData.invoice_due_at"
                                            id="invoice_due_at"
                                            :items="[{'id': '0', 'name': 'Invoice Date'}, {'id': '2', 'name': 'After 2 Days'}, {'id': '7', 'name': 'After 7 Days'}, {'id': '15', 'name': 'After 15 Days'}, {'id': '30', 'name': 'After 30 Days'}]"
                                            :placeholder="'Select Due At'"
                                            :searchable="false"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="row">
                                    <div class="col-md-12">
                                        <label for="description" class="form-label">Comment</label>
                                        <textarea
                                            class="form-control"
                                            id="description"
                                            rows="4"
                                            v-model="updateOrderData.comment"
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label for="discount" class="form-label">Total Amount</label>
                                        <input
                                            readonly
                                            type="number"
                                            class="form-control"
                                            id="order_item_discount_value"
                                            v-model="updateOrderData.total_amount"
                                        />
                                    </div>
                                    <div class="col-md-6">
                                        <label for="discount" class="form-label">Discount(%)</label>
                                        <input
                                            type="number"
                                            class="form-control"
                                            id="order_item_discount_value"
                                            v-model="updateOrderData.order.discount_value"
                                        />
                                    </div>
                                    <div class="col-md-6">
                                        <label for="discount" class="form-label">VAT(%)</label>
                                        <VueSelect
                                            v-model="updateOrderData.order.tax"
                                            :items="[{ id: '0', name: '0' },{ id: tax, name: tax }]"
                                            :placeholder="'Select VAT'"
                                            :searchable="false"
                                        ></VueSelect>
                                        <!-- <Select2
                                            v-model="updateOrderData.order.tax"
                                            :options="[
                                                { id: '0', text: '0' },
                                                { id: tax, text: tax },
                                            ]"
                                            :settings="{
                                                minimumResultsForSearch:
                                                    'Infinity',
                                                placeholder: 'Select VAT',
                                            }"
                                        /> -->
                                    </div>
                                    <div class="col-md-6">
                                        <label for="discount" class="form-label">Net Amount</label>
                                        <input
                                            readonly
                                            type="number"
                                            class="form-control"
                                            id="order_item_discount_value"
                                            v-model="updateOrderData.final_amount"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <label for="description" class="form-label">Attachment</label>
                                <ImageUploader ref="imageUploader" :orderId="updateOrderData.id" />
                            </div>
                            <!-- Setup recurring services -->
                            <div v-if="filteredScheduledServices.length === 0" class="col-md-12">
                                <div class="form-check form-switch">
                                    <input 
                                        class="form-check-input cursor-pointer" 
                                        type="checkbox" 
                                        id="certificate" 
                                        v-model="setupRecurringServices"
                                        @change="handleSetupRecurringServices"
                                    >
                                    <label class="form-check-label cursor-pointer" for="certificate">Setup Recurring Services?</label>
                                </div>
                            </div>
                            <!-- Dispaly recurring services -->
                            <div v-if="filteredScheduledServices.length > 0" class="col-md-12">
                                <div class="alert alert-light p-2 hm-fs-11 rounded-1">
                                    <div v-for="(service, index) in filteredScheduledServices" :key="index">
                                        <h6 class="mb-0">{{ service.service_name }}</h6>
                                        <div class="d-flex gap-2 align-items-center ">
                                            <div><strong>Frequency:</strong> {{ service.frequency }},</div>
                                            <div><strong>Next Schedule:</strong> {{ service.formatted_next_date }}</div>
                                            <div class="action-buttons"><i class="bi bi-pencil cursor-pointer" @click="$refs.setupRecurringServices.editScheduledService({id: service.id})"></i></div>
                                        </div>
                                        <!-- Display hr if service is not first item and not the last item -->
                                        <hr v-if="index < filteredScheduledServices.length - 1">
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-md-12">
                                <div class="form-check form-switch">
                                    <input class="form-check-input cursor-pointer" type="checkbox" id="certificate" v-model="displayRecurringServices">
                                    <label class="form-check-label cursor-pointer" for="certificate">{{ displayRecurringServices ? 'Hide Recurring Services' : 'Show Recurring Services'}}</label>
                                </div>
                            </div>

                            <RecurringServices
                                v-if="displayRecurringServices && updateOrderData.order.customer_id"
                                :order-data="updateOrderData"
                                ref="recurringServices"
                            ></RecurringServices> -->

                            <div class="col-md-12" v-if="updateOrderData.order && updateOrderData.order.address_id && updateOrderData.order.customer_id">
                                <RecurringScheduledServices
                                    @services-loaded="handleRecurringServicesLoaded"
                                    :address-id="updateOrderData.order.address_id"
                                    :customer-id="updateOrderData.order.customer_id"
                                ></RecurringScheduledServices>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <a
                            type="button"
                            class="text-theme pe-3"
                            data-bs-dismiss="modal"
                            @click="cancelItemDrop"
                            >Cancel</a
                        >
                        <button
                            type="button"
                            class="btn btn-theme btn-sm"
                            v-text="isLoading ? 'Loading...' : 'Submit'"
                            @click="updateOrder"
                        ></button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Display order detail view -->
        <div class="modal fade" id="viewOrderDetail" tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content bg-white">
                    <div class="modal-header">
                        <h5 class="modal-title">Order Detail</h5>
                        <!-- <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button> -->
                    </div>
                    <div
                        v-if="Object.keys(orderDetails).length > 0"
                        class="modal-body"
                    >
                        <div class="row">
                            <div class="col-md-6">
                                <label class="label">Order ID</label>
                                <p>{{ orderDetails.order_number }}</p>
                            </div>
                            <div class="col-md-6">
                                <label class="label">Price</label>
                                <p>£{{ orderDetails.final_amount }}</p>
                            </div>
                            <template
                                v-if="orderDetails.account_type === 'business'"
                            >
                                <div class="col-md-6">
                                    <label class="label">Company Name</label>
                                    <p>{{ orderDetails.full_name }}</p>
                                </div>
                                <div class="col-md-6">
                                    <label class="label"
                                        >Business Contact Person</label
                                    >
                                    <p>{{ orderDetails.bcp_full_name }}</p>
                                </div>
                                <div class="col-md-6">
                                    <label class="label">Billing Address</label>
                                    <p>{{ orderDetails.billing_address }}</p>
                                </div>
                            </template>

                            <template
                                v-else-if="
                                    orderDetails.account_type === 'individual'
                                "
                            >
                                <div class="col-md-6">
                                    <label class="label">Customer Name</label>
                                    <p>{{ orderDetails.full_name }}</p>
                                </div>
                            </template>

                            <div
                                v-if="orderDetails.account_type === 'business'"
                                class="col-md-6"
                            >
                                <label class="label"
                                    >Address Contact Person</label
                                >
                                <p>
                                    {{ orderDetails.contact_person_full_name }}
                                </p>
                            </div>

                            <div class="col-md-6">
                                <label class="label">Address</label>
                                <p>{{ orderDetails.booking_address }}</p>
                            </div>
                            <div class="col-md-6">
                                <label class="label">Post Code</label>
                                <p>{{ orderDetails.postal_code }}</p>
                            </div>

                            <div class="col-md-6">
                                <label class="label"
                                    >Contact Person Phone</label
                                >
                                <p>
                                    {{
                                        orderDetails.contact_person_phone_number !=
                                        ""
                                            ? orderDetails.contact_person_phone_number
                                            : orderDetails.phone_number
                                    }}
                                </p>
                            </div>
                            <div class="col-md-6">
                                <label class="label">Assigned To</label>
                                <p>
                                    {{
                                        orderDetails.handyman_full_name != ""
                                            ? orderDetails.handyman_full_name
                                            : "N/A"
                                    }}
                                </p>
                            </div>
                            <div class="col-md-6">
                                <label class="label">Due Date</label>
                                <p>
                                    {{
                                        orderDetails.booking_date != ""
                                            ? formatDate(
                                                  orderDetails.booking_date,
                                                  "DD-MMM-YYYY"
                                              )
                                            : "N/A"
                                    }}
                                </p>
                            </div>
                        </div>
                        <!-- Display order items -->
                        <h5 class="card-title mt-2">Order Items</h5>
                        <table class="table table-bordered align-middle">
                            <thead>
                                <tr>
                                    <th scope="col">Item Name</th>
                                    <th scope="col" class="text-center">
                                        Item Price
                                    </th>
                                    <th scope="col" class="text-center">
                                        Labour Cost
                                    </th>
                                    <th scope="col" class="text-center">Tax</th>
                                    <th scope="col" class="text-center">
                                        Discount
                                    </th>
                                    <th scope="col" class="text-center">
                                        Total
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(
                                        item, index
                                    ) in orderDetails.order_items"
                                    :key="index"
                                >
                                    <td>{{ item.service_name }}</td>
                                    <td class="text-center">
                                        £{{ item.order_item_price }}
                                    </td>
                                    <td class="text-center">
                                        £{{ item.order_item_labour_cost }}
                                    </td>
                                    <td class="text-center">
                                        £{{ item.order_tax_amount }}
                                    </td>
                                    <td class="text-center">
                                        £{{ item.order_discount_amount }}
                                    </td>
                                    <td class="text-center">
                                        £{{ item.order_item_total_amount }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <!-- Add Attachment Modal -->
        <div
            class="modal fade"
            id="addAttachmentModal"
            tabindex="-1"
            aria-labelledby="addAttachmentModalLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="addAttachmentModalLabel">
                            Add Attachment
                        </h5>
                        <!-- <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button> -->
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <label for="reasonInput" class="form-label"
                                >Comment for Attachment</label
                            >
                            <textarea
                                class="form-control"
                                id="reasonInput"
                                v-model="updateOrderData.comment"
                            ></textarea>
                        </div>
                        <div class="col-md-12 mb-3">
                            <label for="description" class="form-label">Attachment</label>
                            <ImageUploader ref="attachmentImageUploader" :orderId="updateOrderData.id" />
                            <!-- <div class="input-group mb-3">
                                <input
                                    type="file"
                                    class="form-control"
                                    multiple
                                    @change="onFileChange"
                                />
                            </div>

                            <img
                                v-for="previewImage in previewOrderImages"
                                :src="previewImage"
                                class="img-thumbnail me-2 mb-2"
                                style="{max-height: 150px;max-width: 150px;}"
                                :key="previewImage"
                            /> -->
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            @click="cancelAddAttachment"
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            class="btn btn-primary"
                            @click="addAttachment"
                            :disabled="processing"
                            :class="{'disabled': processing}"
                            v-text="processing ? 'Processing...' : 'Confirm'"
                        ></button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Reassign Order Modal -->
        <div class="modal fade" id="reassignOrderModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-lg">
                <div class="modal-content bg-white">
                    <div class="modal-header">
                        <h5 class="modal-title">Task Reassign To</h5>
                        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
                    </div>
                    <div class="modal-body">
                        <form class="row g-3">
                            <div class="col-md-4">
                                <label for="customer_name" class="form-label">Client Name</label>
                                <input
                                    type="text"
                                    class="form-control disabled"
                                    id="customer_name"
                                    disabled
                                    v-model="updateOrderData.order.full_name"
                                />
                            </div>
                            <div class="col-md-4">
                                <label for="order_id" class="form-label">Order ID</label>
                                <input
                                    type="text"
                                    class="form-control disabled"
                                    id="order_id"
                                    disabled
                                    v-model="updateOrderData.order.order_number"
                                />
                            </div>
                            <div class="col-md-4">
                                <label for="phone_number" class="form-label">Mobile Number</label>
                                <input
                                    type="text"
                                    class="form-control disabled"
                                    id="phone_number"
                                    disabled
                                    v-model="updateOrderData.order.phone_number"
                                />
                            </div>
                            <div class="col-md-4">
                                <label for="email" class="form-label">Email</label>
                                <input
                                    type="text"
                                    class="form-control disabled"
                                    id="email"
                                    disabled
                                    v-model="updateOrderData.order.email"
                                />
                            </div>
                            <div class="col-md-8">
                                <label for="email" class="form-label">Address</label>
                                <textarea
                                    class="form-control disabled"
                                    id="email"
                                    rows="1"
                                    disabled
                                    v-model="updateOrderData.order.booking_address"
                                ></textarea>
                            </div>
                            <hr class="mb-0"/>
                            <div class="col-md-4">
                                <label for="assign_date" class="form-label">Assign Date <span class="text-danger">*</span></label>
                                <BookingDatePicker
                                    v-model="updateOrderData.order_booking_date"
                                    :format="'dd-MM-yyyy'"
                                    :time-picker="false"
                                    :auto-apply="true"
                                />
                            </div>
                            <div class="col-md-4">
                                <label for="assign_date" class="form-label">Assign Time <span class="text-danger">*</span></label>
                                <!-- <VueDatePicker
                                    v-model="updateOrderData.order_booking_time"
                                    time-picker :is-24="false"
                                    :clearable="false"
                                    :minutes-grid-increment="10"
                                    :minutes-increment="15"
                                >
                                    <template #input-icon>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clock-11 hm-time-icons"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 9.5 8"/></svg>
                                    </template>
                                </VueDatePicker> -->
                                <TimePicker v-model="updateOrderData.order_booking_time" placeholder="Select Time" />
                            </div>
                            <div class="col-md-4">
                                <label for="assign_handyman" class="form-label">Task Assign To <span class="text-danger">*</span></label>
                                <VueSelect
                                    v-model="updateOrderData.handyman_id"
                                    :items="handymanList"
                                    :multiple="true"
                                    :placeholder="'Select Handyman'"
                                    @onSelectOption="onSelectHandyman"
                                ></VueSelect>
                                <small v-if="handymanList.length === 0" class="text-danger">Please select valid assign date and time for task.</small>
                            </div>
                            <div class="col-md-6">
                                <div class="form-check form-check-inline pb-1">
                                    <input
                                        class="form-check-input"
                                        type="radio"
                                        name="assign_duration"
                                        id="hours"
                                        value="hours"
                                        v-model="updateOrderData.assigned_duration_type"
                                    >
                                    <label class="form-check-label" for="hours">Time Duration (In Hours)</label>
                                </div>
                                <div class="form-check form-check-inline pb-1">
                                    <input
                                        class="form-check-input"
                                        type="radio"
                                        name="assign_duration"
                                        id="full_day"
                                        value="full_day"
                                        v-model="updateOrderData.assigned_duration_type"
                                    >
                                    <label class="form-check-label" for="full_day">Full Day</label>
                                </div>
                                <input
                                    type="number"
                                    class="form-control"
                                    id="assign_duration"
                                    :class="{'disabled': updateOrderData.assigned_duration_type === 'full_day'}"
                                    :disabled="updateOrderData.assigned_duration_type === 'full_day'"
                                    v-model="updateOrderData.assigned_duration"
                                />
                                <small v-if="updateOrderData.assigned_duration < 1" class="text-danger">Please enter minimum 1 hour.</small>
                            </div>
                            <div class="col-md-6">
                                <label for="description" class="form-label">Comment</label>
                                <textarea
                                    class="form-control"
                                    id="description"
                                    rows="1"
                                    v-model="updateOrderData.comment"
                                ></textarea>
                            </div>

                            <div class="col-md-12">
                                <label for="description" class="form-label">Attachment</label>
                                <ImageUploader ref="reassignOrderImageUploader" :orderId="updateOrderData.id" />
                                <!-- <div class="input-group mb-3">
                                    <input
                                        type="file"
                                        class="form-control"
                                        multiple
                                        @change="onFileChange"
                                    />
                                </div>

                                <img
                                    v-for="previewImage in previewOrderImages"
                                    :src="previewImage"
                                    class="img-thumbnail me-2 mb-2"
                                    style="{max-height: 150px;max-width: 150px;}"
                                    :key="previewImage"
                                /> -->
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <a
                            type="button"
                            class="text-theme pe-3"
                            data-bs-dismiss="modal"
                            v-text="'Cancel'"
                        ></a>
                        <button
                            type="button"
                            class="btn btn-theme btn-sm"
                            v-text="isLoading ? 'Loading...' : 'Save Task'"
                            @click="assignOrder('reassign')"
                        ></button>
                    </div>
                </div>
            </div>
        </div>

        <!--Cancel Order Modal-->
        <div class="modal fade" id="cancelOrderModal" tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content bg-white">
                    <div class="modal-header">
                        <h5 class="modal-title">Cancel Order</h5>
                        <!-- <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button> -->
                    </div>
                    <div class="modal-body">
                        <form class="row g-3">
                            <!-- First display existing services -->
                            <div
                                class="row mb-3"
                                v-if="Object.keys(quotationService.items).length > 0"
                                v-for="(item, index) in quotationService.items"
                            >
                                <!-- <div class="col-md-3">
                                    <template v-if="index === 0">
                                        <label for="customer_name" class="form-label">Service Type</label>
                                    </template>
                                    <Select2
                                        v-model="quotationService.items[index].item_type                                        "
                                        :options="serviceTypes"
                                        :settings="{
                                            placeholder: 'Service Type',
                                            selectionCssClass: 'test',
                                            dropdownCssClass:'popup-select2-dropdown',
                                        }"
                                        :class="{'is-invalid':quotationService.items[index].item_type === ''}"
                                    />
                                </div> -->
                                <div class="col-md-6">
                                    <template v-if="index === 0">
                                        <label for="customer_name" class="form-label" >Service Name</label>
                                    </template>
                                    <!-- <template v-if="quotationService.items[index].item_type === 'service'">
                                        <Select2
                                            v-model="quotationService.items[index].service_id"
                                            :options="serviceOptions"
                                            :settings="{
                                                placeholder: 'Select Service',
                                                selectionCssClass: 'test',
                                                dropdownCssClass:'popup-select2-dropdown',
                                            }"
                                            @select="calculateServiceItemAmount('service',index)"
                                            :class="{'is-invalid':quotationService.items[index].service_id === '',}"
                                        />
                                    </template>
                                    <template
                                        v-else-if="quotationService.items[index].item_type === 'package'"
                                    >
                                        <Select2
                                            v-model="quotationService.items[index].package_id"
                                            :options="packageOptions"
                                            :settings="{placeholder: 'Select Package',}"
                                            @select="calculateServiceItemAmount('package',index)"
                                            :class="{'is-invalid':quotationService.items[index].package_id === '',}"
                                        />
                                    </template>
                                    <template v-else>
                                        <Select2
                                            :options="[
                                                {
                                                    id: ' ',
                                                    text: 'Select Service',
                                                },
                                            ]"
                                            :settings="{
                                                placeholder: 'Select Service',
                                            }"
                                            :class="{
                                                'is-invalid':
                                                    quotationService.items[
                                                        index
                                                    ].service_id === '',
                                            }"
                                        />
                                    </template> -->
                                    <!-- <SelectService
                                        v-model="quotationService.items[index].service_id"
                                        :services="serviceOptions"
                                        :taggable="false"
                                        :multiple="false"
                                        :disabled="true"
                                        @updateServiceName="quotationService.items[index].service_name = $event; calculateServiceItemAmount('service',index)"
                                    /> -->
                                    <VueSelect
                                        v-model="quotationService.items[index].service_id"
                                        :items="serviceOptions"
                                        :taggable="false"
                                        :multiple="false"
                                        :disabled="true"
                                        @updateLabel="quotationService.items[index].service_name = $event; calculateServiceItemAmount('service',index)"
                                    ></VueSelect>
                                </div>
                                <div class="col-md-2 item-fields-number">
                                    <template v-if="index === 0">
                                        <label for="item_price" class="form-label">Item Cost</label>
                                    </template>
                                    <input
                                        type="number"
                                        class="form-control"
                                        id="item_price"
                                        readonly
                                        v-model="quotationService.items[index].order_item_price"
                                    />
                                </div>
                                <div class="col-md-2 item-fields-number">
                                    <template v-if="index === 0">
                                        <label for="labour_cost" class="form-label">Labour Cost</label>
                                    </template>
                                    <input
                                        type="number"
                                        class="form-control"
                                        id="labour_cost"
                                        readonly
                                        v-model="quotationService.items[index].order_item_labour_cost"
                                    />
                                </div>
                                <div class="col-md-2 item-fields-number">
                                    <template v-if="index === 0">
                                        <label for="discount" class="form-label">Discount(%)</label>
                                    </template>
                                    <input
                                        type="number"
                                        class="form-control"
                                        id="order_item_discount_value"
                                        readonly
                                        v-model="quotationService.items[index].order_item_discount_value"
                                        @input="validateInput('service', index)"
                                    />
                                </div>
                                <!-- <div class="col-md-1 text-nowrap ps-0">
                                    <template v-if="index === 0">
                                        <div class="pt-4 mt-2"></div>
                                    </template>
                                </div> -->
                            </div>
                            <div class="col-md-7">
                                <div class="row">
                                    <div class="col-md-12">
                                        <label for="description" class="form-label">Comment</label>
                                        <textarea
                                            class="form-control"
                                            id="description"
                                            rows="4"
                                            v-model="updateOrderData.comment"
                                        ></textarea>
                                    </div>
                                    <div class="col-md-12">
                                        <label for="description" class="form-label">Attachment</label>
                                        <div class="input-group mb-3">
                                            <input
                                                type="file"
                                                class="form-control"
                                                multiple
                                                @change="onFileChange"
                                            />
                                        </div>

                                        <!-- Display image preview -->
                                        <img
                                            v-for="previewImage in previewOrderImages"
                                            :src="previewImage"
                                            class="img-thumbnail me-2 mb-2"
                                            style="{max-height: 150px;max-width: 150px;}"
                                            :key="previewImage"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <div class="row">
                                    <div class="col-md-12">
                                        <label for="discount" class="form-label">Total Amount</label>
                                        <input
                                            readonly
                                            type="number"
                                            class="form-control"
                                            id="order_item_discount_value"
                                            v-model="updateOrderData.total_amount"
                                        />
                                    </div>
                                    <div class="col-md-12">
                                        <label for="discount" class="form-label">Discount(%)</label>
                                        <input
                                            type="number"
                                            class="form-control"
                                            id="order_item_discount_value"
                                            readonly
                                            v-model="updateOrderData.order.discount_value"
                                        />
                                    </div>
                                    <div class="col-md-12">
                                        <label for="discount" class="form-label">VAT(%)</label>
                                        <!-- <Select2
                                            v-model="updateOrderData.order.tax"
                                            :options="[{ id: '0', text: '0' },{ id: tax, text: tax }]"
                                            :settings="{minimumResultsForSearch: 'Infinity', placeholder: 'Select VAT',}"
                                        /> -->
                                        <VueSelect
                                            v-model="updateOrderData.order.tax"
                                            :items="[{ id: '0', name: '0' },{ id: tax, name: tax }]"
                                            :placeholder="'Select VAT'"
                                            :searchable="false"
                                        ></VueSelect>
                                    </div>
                                    <div class="col-md-12">
                                        <label for="discount" class="form-label">Net Amount</label>
                                        <input
                                            readonly
                                            type="number"
                                            class="form-control"
                                            id="order_item_discount_value"
                                            v-model="updateOrderData.final_amount"
                                        />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <a
                            type="button"
                            class="text-theme pe-3"
                            data-bs-dismiss="modal"
                        >Close</a>
                        <button
                            type="button"
                            class="btn btn-theme btn-sm"
                            v-text="isLoading ? 'Processing...' : 'Cancel Order'"
                            @click="updateOrder"
                        ></button>
                    </div>
                </div>
            </div>
        </div>

        <!-- View customer details -->

        <!-- View customer details modal popup -->
        <CustomerDetails
            :order="customerDetails"
            :currencySymbol="currencySymbol"
        />
        <FilterReports />

        <!-- Setup recurring services -->
        <SetupRecurringServices
            v-if="updateOrderData.order.id > 0"
            ref="setupRecurringServices"
            :services="quotationService?.items || []"
            :orderId="updateOrderData.order.id"
            :addressId="updateOrderData.order.address_id"
            :customerId="updateOrderData.order.customer_id"
            source="move-to-completed"
            @services-fetched="getRecurringSummary"
        />
    </div>
</template>

<script>
import draggable from "vuedraggable";
import Select2 from "vue3-select2-component";
import moment from "moment";
import VueSimpleContextMenu from "vue-simple-context-menu";
import "vue-simple-context-menu/dist/vue-simple-context-menu.css";
import BookingDatePicker from "./BookingDatePicker";
import RecurringServices from "./RecurringServices";
import GoogleMap from "./GoogleMap";
import SelectService from "./partials/SelectService";
import VueSelect from "./partials/VueSelect";
import FilterReports from "./partials/FilterReports";
import { appMixin } from "../mixin/appMixin";
import ImageUploader from "./Order/ImageUploader";
import CustomerDetails from "./Order/CustomerDetails";
import SetupRecurringServices from "./Order/SetupRecurringServices";
import RecurringScheduledServices from "./ScheduledServices/RecurringScheduledServices";
import TimePicker from "./partials/TimePicker";

export default {
    components: {
        draggable,
        Select2,
        VueSimpleContextMenu,
        BookingDatePicker,
        RecurringServices,
        GoogleMap,
        SelectService,
        VueSelect,
        FilterReports,
        ImageUploader,
        CustomerDetails,
        SetupRecurringServices,
        RecurringScheduledServices,
        TimePicker
    },
    mixins: [appMixin],
    data() {
        return {
            tax: 20,
            drag: false,
            loading: false,
            isDraggable: false,
            searchOrder:'',
            errors: {},
            orderOptions: [],
            allOrders:{},
            orderOptionAvailable: {
                pending: [
                    {name: "Move To Assigned", job: "bucket-move", moveToStatus: "assigned", moveFromStatus: "pending" },
                    {name: "View Order", job: "order-view" },
                    {name: "View Customer", job: "view-customer" },
                    {name: "Add Attachment", job: "add-attachment" },
                    {name: "Cancel Order", job: "cancel" },
                    {name: "Duplicate Order", job: "duplicate" },
                ],
                assigned: [
                    {name: "Move To Processing", job: "bucket-move", moveToStatus: "processing", moveFromStatus: "assigned"},
                    {name: "Back To Pending", job: "bucket-move", moveToStatus: "pending", moveFromStatus: "assigned"},
                    {name: "View Order", job: "order-view" },
                    {name: "View Customer", job: "view-customer" },
                    {name: "Add Attachment", job: "add-attachment" },
                    {name: "Reassign Order", job: "reassign-order" },
                    {name: "Cancel Order", job: "cancel" },
                    {name: "Duplicate Order", job: "duplicate" },
                ],
                processing: [
                    {name: "Back To Pending", job: "bucket-move", moveToStatus: "pending", moveFromStatus: "processing"},
                    {name: "Move To Quotation", job: "bucket-move", moveToStatus: "quotation", moveFromStatus: "processing"},
                    {name: "Move To Completed", job: "bucket-move", moveToStatus: "completed", moveFromStatus: "processing"},
                    {name: "Back To Assigned", job: "bucket-move", moveToStatus: "assigned", moveFromStatus: "processing"},
                    {name: "View Order", job: "order-view" },
                    {name: "View Customer", job: "view-customer" },
                    {name: "Add Attachment", job: "add-attachment" },
                    {name: "Cancel Order", job: "cancel" },
                    {name: "Duplicate Order", job: "duplicate" },
                ],
                quotation: [
                    {name: "Move To Completed", job: "bucket-move", moveToStatus: "completed", moveFromStatus: "quotation"},
                    {name: "Back To Processing", job: "bucket-move", moveToStatus: "processing", moveFromStatus: "quotation"},
                    {name: "Quotation Declined", job: "bucket-move", moveToStatus: "declined", moveFromStatus: "quotation"},
                    {name: "Quotation Approved", job: "bucket-move", moveToStatus: "pending", moveFromStatus: "quotation"},
                    {name: "View Order", job: "order-view" },
                    {name: "View Customer", job: "view-customer" },
                    {name: "Add Attachment", job: "add-attachment" },
                    {name: "Cancel Order", job: "cancel" },
                    {name: "Duplicate Order", job: "duplicate" },
                ],
                engineer_completed: [
                    {name: "Move To Completed",job: "bucket-move",moveToStatus: "completed",moveFromStatus: "engineer_completed"},
                    {name: "Move To Quotation", job: "bucket-move", moveToStatus: "quotation", moveFromStatus: "processing"},
                    {name: "Back To Processing",job: "bucket-move",moveToStatus: "processing",moveFromStatus: "engineer_completed"},
                    {name: "View Order", job: "order-view" },
                    {name: "View Customer", job: "view-customer" },
                    {name: "Add Attachment", job: "add-attachment" },
                    {name: "Cancel Order", job: "cancel" },
                    {name: "Duplicate Order", job: "duplicate" },
                ],
                completed: [
                    {name: "Back To Quotation", job: "bucket-move", moveToStatus: "quotation", moveFromStatus: "completed"},
                    {name: "View Order", job: "order-view" },
                    {name: "View Customer", job: "view-customer" },
                    {name: "View Invoice", job: "invoice-view" },
                    {name: "Add Attachment", job: "add-attachment" },
                    {name: "Cancel Order", job: "cancel" },
                    {name: "Duplicate Order", job: "duplicate" },
                ],
                declined: [
                    {name: "Back To Pending", job: "bucket-move", moveToStatus: "pending", moveFromStatus: "processing"},
                    {name: "Back To Quotation", job: "bucket-move", moveToStatus: "quotation", moveFromStatus: "declined"},
                    {name: "View Order", job: "order-view" },
                    {name: "View Customer", job: "view-customer" },
                    {name: "View Invoice", job: "invoice-view" },
                    //{name: "Add Attachment", job: "add-attachment" },
                    //{name: "Cancel Order", job: "cancel" },
                    {name: "Duplicate Order", job: "duplicate" },
                ],
                temporary: [
                    {name: "Approve Order", job: "approve_order"},
                    {name: "Move To Assigned", job: "bucket-move", moveToStatus: "assigned", moveFromStatus: "pending" },
                    {name: "View Order", job: "order-view" },
                    {name: "View Customer", job: "view-customer" },
                    {name: "Add Attachment", job: "add-attachment" },
                    {name: "Cancel Order", job: "cancel" },
                    {name: "Duplicate Order", job: "duplicate" },
                ],
            },
            statusHierarchy: {
                pending: 1,
                assigned: 2,
                processing: 3,
                quotation: 4,
                completed: 5,
                declined: 6,
            },
            serviceTypes: [
                { id: "", Text: "Select" },
                { id: "service", text: "Services" },
                { id: "package", text: "Packages" },
            ],
            orderTypes: [
                { type: "pending", text: "Pending" },
                { type: "assigned", text: "Assigned" },
                { type: "processing", text: "Processing" },
                { type: "quotation", text: "Quotation" },
                { type: "engineer_completed", text: "Engineer Completed" },
                { type: "completed", text: "Completed" },
                { type: "declined", text: "Declined" },
            ],
            backwardReason: "", // Reason for moving an order backward
            orders: {
                all: [],
                pending: [],
                assigned: [],
                processing: [],
                quotation: [],
                engineer_completed: [],
                completed: [],
                declined: [],
            },
            pendingOrders: [],
            assignedOrders: [],
            processingOrders: [],
            completedOrders: [],
            declinedOrders: [],
            handymanUsers: [],
            handymanOptions: [],
            previewOrderImages: [],
            engineerCompletedOrders: [],
            updateOrderData: {
                order: {},
                order_id: "",
                handyman_id: "",
                booking_date: "",
                assigned_duration: "",
                final_amount: 0,
                action: "assign",
                comment: "",
                status: "pending",
                files: [],
                order_booking_date: "",
                order_booking_time: {hours: 9,minutes: 17},
                invoice_number: "",
                invoice_date: this.moment(new Date()).format('YYYY-MM-DD'),
                invoice_due_at: "7",
                submit_form: false
            },
            isLoading: false,
            isAssignFormValid: false,
            moveFromStatus: "",
            moveToStatus: "",
            fixedStatusColumn: "",
            minDatetime: "",
            services: [],
            packages: [],
            serviceOptions: [],
            packageOptions: [],
            quotationService: {
                order_id: "",
                comment: "",
                items: [],
                files: [],
                old_items: [],
            },
            orderDetails: {},
            screenHeight: "",
            dragItem: {},
            dragItemIndex: "",
            docRecieved: false,
            enggDocReady: false, // Engineer document ready
            selectedFilterDate: "",
            //handymanSchedules: [],
            isHandymanAvailable: false,
            allowedBookingDates: [],
            currentDate: '',
            currentMonth: '',
            startOfWeek: '',
            endOfWeek: '',
            daysOptions: ['today', 'tomorrow', 'yesterday', 'custom_day'],
            weekOptions: ['previous_week','this_week', 'next_week', 'custom_week'],
            monthOptions: ['previous_month','this_month', 'next_month' , 'custom_month'],
            mapOrders: [],
            displayMapOrList: 'list',
            customerDetails: {
                customer: {
                    account_type: 'individual',
                    name: '',
                    phone_number: '',
                    email: '',
                    cp_name: '',
                    cp_type: '',
                    cp_phone_number: '',
                    customer_name: '',
                    customer_phone: '',
                },
                services: [],
                service_address: '',
                price: 0,
                service_date: '',
                service_time: '',
            },
            orderCreatedByDuplicate: false, // Duplicate order number used to identify duplicate order created
            displayRecurringServices: true,

            touchTimer: null,
            touchStartX: 0,
            touchStartY: 0,
            isTouchMoving: false,
            processing: false,
            handymanList: [],
            isPendingLoading: false,
            isAssignedLoading: false,
            isProcessingLoading: false,
            isQuotationLoading: false,
            isCompletedLoading: false,
            isDeclinedLoading: false,
            isEngineerCompletedLoading: false,
            setupRecurringServices: false,
            scheduledServices: [],
            visibleRecurringServices: [],
        };
    },
    computed: {
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost",
            };
        },
        handymanSchedules() {
            return this.$store.state.availableSchedules;
        },
        currencySymbol() {
            return this.$store.state.systemSettings?.currency?.symbol || '£';
        },
        filteredScheduledServices() {
            if (this.visibleRecurringServices.length === 0) {
                return this.scheduledServices;
            }
            return this.scheduledServices.filter(service => {
                // Check if this service is present in visibleRecurringServices
                // visibleService.id is the Service ID
                // service.service_id is likely the Service ID in the scheduled list (from SetupRecurringServices)
                // We check both just in case service.id is the service ID in some contexts
                return !this.visibleRecurringServices.some(visibleService => 
                    visibleService.id === service.service_id || visibleService.id === service.id
                );
            });
        },
        isMobile() {
            return window.innerWidth <= 768; // Adjust based on your needs
        }
    },
    mounted() {
        //this.handleDebouncedScroll = debounce(this.handleScroll, 100);
        window.addEventListener("scroll", this.handleScroll);

        this.getServicesForOrder();

        this.screenHeight = window.innerHeight - 170;

        window.addEventListener("resize", () => {
            this.screenHeight = window.innerHeight - 170;
            this.updateMobileState;
        });

        // Handle modal close event updateOrderData
        $("#updateOrderData").on("hidden.bs.modal", () => {
            this.updateOrderData.order = {};
            this.scheduledServices = [];
        });
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.updateMobileState);
    },
    unmounted() {
        //window.removeEventListener('scroll', this.handleScroll);
    },
    created() {
        this.currentDate = moment().format('YYYY-MM-DD');
        this.startOfWeek = moment().startOf('isoWeek').format('YYYY-MM-DD');
        this.endOfWeek = moment().endOf('isoWeek').format('YYYY-MM-DD');
        this.currentMonth = moment();

        this.getOrders();
        this.getHandymanUsers();
        //this.$notification('error', 'Thre is an errro');

        // Set the minimum datetime to the current datetime
        this.setMinDatetime();

        // Get handyman schedules
        //this.getHandymanSchedules();
    },
    methods: {
        validateInput(type, index) {
            // Ensure the entered value is not greater than 100
            if (this.quotationService.items[index].order_item_discount_value > 100) {
                this.quotationService.items[index].order_item_discount_value = 100;
            }
        },
        orderItemMenuAction(event) {
            let self = this;
            if (event.option.job === "bucket-move") {
                this.moveFromStatus = event.option.moveFromStatus;
                this.moveToStatus = event.option.moveToStatus;
                this.dragItem = event.item;
                const indexToDelete = this.orders[
                    this.moveFromStatus
                ].findIndex((order) => order.id === this.dragItem.id);
                if (indexToDelete !== -1) {
                    this.orders[this.moveFromStatus].splice(indexToDelete, 1);
                }
                //move to destination bucket
                this.orders[this.moveToStatus].splice(0, 0, this.dragItem);
                this.onChangeItem({
                    added: {
                        element: event.item,
                    },
                });
            } else if (event.option.job === "invoice-view") {
                //window.open("/admin/invoice/download/" + event.item.order_number,"_blank");
                window.location.href = "/admin/invoice/download/" + event.item.order_number;
            } else if (event.option.job === "order-view") {
                //window.open("/admin/orders/" + event.item.order_number, "_blank");
                window.location.href = "/admin/orders/" + event.item.order_number;
            } else if (event.option.job === "add-attachment") {
                this.updateOrderData.id = event.item.id;
                this.updateOrderData.status = event.item.status;
                this.updateOrderData.files = [];
                this.updateOrderData.comment = "";
                $("#addAttachmentModal").modal("show");
            }
            else if(event.option.job === 'reassign-order') {
                let item = event.item;
                this.updateOrderData.order = item;
                this.updateOrderData.order_id = item.id;
                this.updateOrderData.status = 'assigned';
                this.updateOrderData.action = "reassign";
                this.updateOrderData.booking_date = item.booking_date;
                this.updateOrderData.assigned_duration = item.assigned_order_duration;

                // Prepare assign_duration_type
                // Check if assign_duration is 8 then mark full day
                if (item.assigned_order_duration === 8) {
                    this.updateOrderData.assigned_duration_type = "full_day";
                }
                else {
                    this.updateOrderData.assigned_duration_type = "hours";
                }

                // Check if booking date is less than today
                // Then set the booking date tomorrow
                if (this.moment(item.booking_date).isBefore(this.moment())) {
                    item.booking_date = this.moment().add(1, 'days');
                }
                this.updateOrderData.order_booking_date = this.formatDate(item.booking_date, "YYYY-MM-DD");
                this.updateOrderData.order_booking_time = { hours: this.formatDate(item.booking_date, "HH"), minutes: this.formatDate(item.booking_date, "mm") };

                // Display selected handymans
                this.updateOrderData.handyman_id = [];
                // Iterate the order handymans
                item.order_handymans.forEach((element) => {
                    this.updateOrderData.handyman_id.push(element.handyman_id);
                });

                // Display the modal
                $('#reassignOrderModal').modal('show');
            }
            else if(event.option.job === 'cancel') {
                let item = event.item;
                this.updateOrderData.order = item;
                this.updateOrderData.order_id = item.id;
                this.updateOrderData.status = 'canceled';
                this.updateOrderData.action = 'canceled';
                this.updateOrderData.final_amount = item.final_amount;

                this.quotationService.items = item.order_items;
                this.quotationService.old_items = JSON.parse(JSON.stringify(item.order_items));

                this.calculateTotalAmount();

                $('#cancelOrderModal').modal('show');
            }
            else if(event.option.job === 'view-customer') {
                let item = event.item;
                this.customerDetails = {
                    id: item.id,
                    order_number: item.order_number,
                    order_type: item.order_type,
                    service_duration: item.assigned_order_duration,
                    postal_code: item.postal_code,
                    service_address: item.booking_address,
                    service_date: item.booking_date,
                    services: item.order_items,
                    total_amount: item.total_amount,
                    price: item.total_amount,
                    access_arrangement: item.access_arrangement,
                    customer: {
                        id: item?.customer_id || '',
                        name: item?.name || '',
                        email: item?.email || '',
                        phone_number: item?.phone_number || '',
                        account_type: item?.account_type || '',
                        cp_name: item?.contact_person_full_name || '',
                        cp_phone: item?.contact_person_phone_number || '',
                        cp_email: item?.contact_person_email || '',
                        cp_type: item?.contact_person_person_type || '',
                        notes: item?.customer_notes || '',
                    },
                    address: {
                        id: item?.address_id || '',
                        address: item?.address || '',
                        postal_code: item?.postal_code || '',
                        full_address: item?.full_address || '',
                        notes: item?.address_notes || '',
                    }
                };



                // Display customer modal details
                $('#viewCustomer').modal('show');
            }
            else if(event.option.job === 'duplicate') {
                let item = event.item;
                // Make request to duplicate order
                axios.post('/admin/orders/duplicate', {order: item.id})
                    .then((response) => {
                        self.$notification(
                            response.data.status,
                            response.data.message
                        );
                        self.getOrders();
                        self.orderCreatedByDuplicate = response.data.order_number;
                    })
                    .catch((error) => {
                        let errors = error.response.data.errors;
                        for (let key in errors) {
                            self.$notification("error", errors[key][0]);
                        }
                    })
                    .finally(() => {

                    });
            }
            else if(event.option.job === 'approve_order') {
                this.approveTemporaryOrder(event.item);
            }
        },
        addAttachment() {
            const config = {
                headers: { "content-type": "multipart/form-data" },
            };

            this.processing = true;
            // Get the selected files from the image uploader
            this.updateOrderData.files = this.$refs.attachmentImageUploader.files.map((file) => file.file);
            axios
                .post("/api/admin/orders/add-attachment",{
                        action_type: "attachment_addded",
                        order_id: this.updateOrderData.id,
                        comment: this.updateOrderData.comment,
                        files: this.updateOrderData.files,
                    },
                    config
                )
                .then((response) => {
                    // Reset the image uploader
                    this.$refs.imageUploader.clearFiles();

                    this.cancelAddAttachment();
                    this.$notification(response.data.status,response.data.message);
                })
                .catch((error) => {
                    this.processing = false;
                    console.log(error);
                })
                .finally(() => {
                    this.processing = false;
                });
        },
        cancelAddAttachment() {
            this.updateOrderData.files = [];
            this.updateOrderData.comment = "";
            $("#addAttachmentModal").modal("hide");
        },
        orderItemClick(event, item) {
            let status = item.status;

            // Check if order is temporary and status is pending then show the different menu
            // if(item.is_approved === 0 && item.order_type === 'temporary') {
            //     status = 'temporary';
            // }

            //this.orderOptions = this.orderOptionAvailable[status];

            // Get the base menu options for the status
            this.orderOptions = [...this.orderOptionAvailable[status]];

            // Add "Confirm" option if order is provisional
            if (this.isProvisionalOrder(item)) {
                this.orderOptions.unshift({
                    name: "Confirm Order", 
                    job: "approve_order"
                });
            }
            this.$refs.orderItemContext.showMenu(event, item);
        },
        handleScroll(event) {
            if (window.scrollY > 93) {
                this.fixedStatusColumn = "fixed-status-column";
            } else {
                this.fixedStatusColumn = "";
            }
        },

        isMovingBackward(currentStatus, targetStatus) {
            return (
                this.statusHierarchy[currentStatus] >
                this.statusHierarchy[targetStatus]
            );
        },
        onFileChange(event) {
            for (let file of event.target.files) {
                try {
                    let reader = new FileReader();

                    // Display the image preview
                    reader.onload = (e) => {
                        this.previewOrderImages.push(e.target.result);
                    };
                    reader.readAsDataURL(file); // Not sure if this will work in this context.
                    this.updateOrderData.files.push(file);

                    // Push the images to the quotation image array
                    this.quotationService.files.push(file);
                } catch {}
            }
        },
        getHandymanUsers() {
            let self = this;
            axios.post("/admin/users/get-handyman-users")
                .then((response) => {
                    self.handymanUsers = response.data.users;

                    // Get id and name of users and push into the userOptions
                    self.handymanOptions = [];
                    response.data.users.forEach((user) => {
                        self.handymanOptions.push({
                            id: user.id,
                            text: user.full_name,
                            name: user.full_name,
                        });
                    });
                });
        },
        getOrders() {
            let self = this;
            //this.isLoading = true;

            // Get the orders by status
            this.getOrdersByStatus('pending');
            this.getOrdersByStatus('assigned');
            this.getOrdersByStatus('processing');
            this.getOrdersByStatus('quotation');
            this.getOrdersByStatus('completed');
            this.getOrdersByStatus('declined');
            this.getOrdersByStatus('engineer_completed');

            return;

            // Get the orders from the server
            axios.post("/admin/orders/list")
                .then((response) => {
                    self.orders.all = response.data.orders;
                    self.orders.pending = response.data.pending;
                    self.orders.assigned = response.data.assigned;
                    self.orders.processing = response.data.processing;
                    self.orders.quotation = response.data.quotation;
                    self.orders.completed = response.data.completed;
                    self.orders.declined = response.data.declined;
                    self.orders.engineer_completed = response.data.engineer_completed;


                    self.allOrders = {
                        all : response.data.orders,
                        pending : response.data.pending,
                        assigned : response.data.assigned,
                        processing : response.data.processing,
                        quotation : response.data.quotation,
                        completed : response.data.completed,
                        declined : response.data.declined,
                        engineer_completed : response.data.engineer_completed
                    }

                    self.pendingOrders = response.data.pending;
                    self.assignedOrders = response.data.assigned;
                    self.processingOrders = response.data.processing;
                    self.completedOrders = response.data.completed;
                    self.declinedOrders = response.data.declined;
                    self.engineerCompletedOrders = response.data.engineer_completed;

                    // Check if order created by duplicate feature then open the assigned modal automatically
                    if (self.orderCreatedByDuplicate) {
                        // Iterate the pending orders and check if order number is same then open the modal
                        self.pendingOrders.forEach((order) => {
                            if (order.order_number === self.orderCreatedByDuplicate) {
                                self.autoOpenAssignModal({
                                    item: order,
                                    moveFromStatus: "pending",
                                    moveToStatus: "assigned",
                                });
                            }
                        });
                    }

                    setTimeout(function() {
                        var maxHeight = 0;
                        $('.order-list-group').each(function() {
                            maxHeight = Math.max(maxHeight, $(this).height());
                        });
                        $('.order-list-group').css({height:maxHeight + 'px'});
                    }, 300)

                    // Generate the map
                    self.initMap();
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    self.isLoading = false;
                });
        },
        getOrdersByStatus(status) {
            let self = this;
            // Set loading based on the status
            if (status === "pending") {
                self.isPendingLoading = true;
            } else if (status === "assigned") {
                self.isAssignedLoading = true;
            } else if (status === "processing") {
                self.isProcessingLoading = true;
            } else if (status === "quotation") {
                self.isQuotationLoading = true;
            } else if (status === "completed") {
                self.isCompletedLoading = true;
            } else if (status === "declined") {
                self.isDeclinedLoading = true;
            } else if (status === "engineer_completed") {
                self.isEngineerCompletedLoading = true;
            }
            // Get the orders from the server
            axios.post("/admin/orders/list", {status: status})
                .then((response) => {
                    if (status === "pending") {
                        self.orders.pending = response.data.pending;
                        self.pendingOrders = response.data.pending;
                        self.allOrders.pending = response.data.pending;
                    } else if (status === "assigned") {
                        self.orders.assigned = response.data.assigned;
                        self.assignedOrders = response.data.assigned;
                        self.allOrders.assigned = response.data.assigned;
                    } else if (status === "processing") {
                        self.orders.processing = response.data.processing;
                        self.processingOrders = response.data.processing;
                        self.allOrders.processing = response.data.processing;
                    } else if (status === "quotation") {
                        self.orders.quotation = response.data.quotation;
                        self.quotationOrders = response.data.quotation;
                        self.allOrders.quotation = response.data.quotation;
                    } else if (status === "completed") {
                        self.orders.completed = response.data.completed;
                        self.completedOrders = response.data.completed;
                        self.allOrders.completed = response.data.completed;
                    } else if (status === "declined") {
                        self.orders.declined = response.data.declined;
                        self.declinedOrders = response.data.declined;
                        self.allOrders.declined = response.data.declined;
                    } else if (status === "engineer_completed") {
                        self.orders.engineer_completed = response.data.engineer_completed;
                        self.engineerCompletedOrders = response.data.engineer_completed;
                        self.allOrders.engineer_completed = response.data.engineer_completed;
                    }

                    // Check if order created by duplicate feature then open the assigned modal automatically
                    if (self.orderCreatedByDuplicate) {
                        // Iterate the pending orders and check if order number is same then open the modal
                        self.pendingOrders.forEach((order) => {
                            if (order.order_number === self.orderCreatedByDuplicate) {
                                self.autoOpenAssignModal({
                                    item: order,
                                    moveFromStatus: "pending",
                                    moveToStatus: "assigned",
                                });
                            }
                        });
                    }

                    setTimeout(function() {
                        var maxHeight = 0;
                        $('.order-list-group').each(function() {
                            maxHeight = Math.max(maxHeight, $(this).height());
                        });
                        $('.order-list-group').css({height:maxHeight + 'px'});
                    }, 300)

                    // Generate the map
                    self.initMap();
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    if (status === "pending") {
                        self.isPendingLoading = false;
                    } else if (status === "assigned") {
                        self.isAssignedLoading = false;
                    } else if (status === "processing") {
                        self.isProcessingLoading = false;
                    } else if (status === "quotation") {
                        self.isQuotationLoading = false;
                    } else if (status === "completed") {
                        self.isCompletedLoading = false;
                    } else if (status === "declined") {
                        self.isDeclinedLoading = false;
                    } else if (status === "engineer_completed") {
                        self.isEngineerCompletedLoading = false;
                    }
                });
        },
        startDrag() {
            this.drag = true;
        },
        endDrag(event) {
            this.drag = false;
        },

        /**
         * If current item statis is pending then check if dragged item is assigned
         * If dragged item is assigned then check if current item status is processing
         * If current item status is processing then check if dragged item is completed
         *
         *
         */
        onMove({ relatedContext, draggedContext }) {

            let relatedElement = relatedContext;
            let relatedComponent = relatedContext.component;
            let dropItem = relatedComponent.componentData;
            let draggedElement = draggedContext.element;

            let dragStatus = draggedElement.status;
            let dropStatus = dropItem.status; //relatedComponent.itemKey;
            //console.log("dragStatus", dragStatus);
            //console.log("dropStatus", dropStatus);

            // Check if dragged item is temporary and status is pending then drag not allowed
            // if(draggedElement.order_type === 'temporary' && draggedElement.is_approved === 0) {
            //     return false;
            // }

            let isDraggable = false;
            if (dragStatus === "pending" && ["assigned"].includes(dropStatus)) {
                isDraggable = true;
            }
            else if (dragStatus === "assigned" && ["pending", "processing"].includes(dropStatus)) {
                isDraggable = true;
            }
            else if (dragStatus === "processing" && ["assigned", "quotation", "completed"].includes(dropStatus)) {
                isDraggable = true;
            }
            else if (dragStatus === "quotation" && ["processing", "completed", "declined"].includes(dropStatus)) {
                isDraggable = true;
            }
            else if(dragStatus === "engineer_completed" && ["processing", "completed", "declined"].includes(dropStatus)) {
                isDraggable = true;
            }
            else if (dragStatus === "completed" && ["processing", "quotation", "declined"].includes(dropStatus)) {
                isDraggable = true;
            }
            else if (dragStatus === "declined" && ["completed", "quotation", "pending"].includes(dropStatus)) {
                isDraggable = true;
            }
            else if (dragStatus === dropStatus) {
                isDraggable = true;
            }
            else {
                isDraggable = false;
            }
            this.isDraggable = isDraggable;
            // Check if drag and drop is not allowed then reset the moveFromStatus and moveToStatus
            if (!isDraggable) {
                //this.moveFromStatus = "";
                //this.moveToStatus = "";
            } else {
                this.moveToStatus = dropStatus;
                this.moveFromStatus = dragStatus;
                this.dragItemIndex = draggedContext.index;
            }

            return isDraggable;
        },
        onChangeItem(event) {
            let self = this;

            // resting all the data after item has been changed to another buckets
            this.errors = {};
            this.previewOrderImages = [];
            this.updateOrderData.files = [];
            this.updateOrderData.comment = "";
            this.quotationService.files = [];
            this.quotationService.comment = "";

            if (event.added) {
                let status = this.moveToStatus;
                let item = event.added.element;
                this.dragItem = item;

                this.updateOrderData.status = this.moveToStatus;
                // First check if moveFromStatus is pending and moveToStatus is assigned
                if (this.moveToStatus == "assigned" || (this.moveFromStatus != "assigned" && this.moveToStatus == "processing")) {
                    const assigned_to = [];
                    item.order_handymans.forEach((e) => {
                        assigned_to.push(e.handyman_id);
                    });
                    this.updateOrderData.order = item;
                    this.updateOrderData.status = this.moveToStatus;
                    this.updateOrderData.order_id = item.id;
                    this.updateOrderData.handyman_id = assigned_to;
                    this.updateOrderData.action = "assign";
                    this.updateOrderData.assigned_duration = item.assigned_order_duration;

                    // Set order type, if not set then mark as regular
                    this.updateOrderData.order_type = item.order_type || "regular";

                    // Prepare assigned_duration_type
                    // Check if assigned_order_duration is 8 then mark full day
                    if (item.assigned_order_duration === 8) {
                        this.updateOrderData.assigned_duration_type = "full_day";
                    }
                    else {
                        this.updateOrderData.assigned_duration_type = "hours";
                    }

                    if(!this.updateOrderData.assigned_duration) {
                        let totalDuration = 0;
                        this.updateOrderData.order.order_items.forEach(e => {
                            totalDuration += parseInt(e.service_duration);
                        });
                        this.updateOrderData.assigned_duration = totalDuration;
                    }

                    // Check if booking date is less than today
                    // Then set the booking date tomorrow at 7:00 am
                    if (this.moment(item.booking_date).isBefore(this.moment())) {
                        item.booking_date = this.moment().add(1, 'days').format('YYYY-MM-DD') + ' 07:00:00';
                    }
                    // Set the booking date tomorrow at 7:00 am
                    //item.booking_date = this.moment().add(1, 'days').format('YYYY-MM-DD') + ' 07:00:00';

                    this.updateOrderData.booking_date = this.formatDate(item.booking_date, "YYYY-MM-DDTHH:mm");
                    this.updateOrderData.order_booking_date = this.formatDate(item.booking_date, "YYYY-MM-DD");
                    this.updateOrderData.order_booking_time = {hours: this.formatDate(item.booking_date, "HH"), minutes: this.formatDate(item.booking_date, "mm")};

                    $("#assignOrderModal").modal({
                        backdrop: "static",
                        keyboard: false,
                    });
                    $("#assignOrderModal").modal("show");
                    return false;
                }

                if (this.isMovingBackward(item.status, this.moveToStatus)) {
                    // This is a backward move; show the confirmation modal
                    this.moveToStatus = this.moveToStatus; // Set the target status for the modal to use
                    $("#confirmBackwardMoveModal").modal("show");
                    return false; // Prevent automatic handling of the move until confirmed
                }

                // Display modal to assign order
                if (this.moveToStatus == "assigned") {
                    this.updateOrderData.order = item;
                    this.updateOrderData.order_id = item.id;
                    const assigned_to = [];
                    item.order_handymans.forEach((e) => {
                        assigned_to.push(e.handyman_id);
                    });
                    this.updateOrderData.handyman_id = assigned_to;
                    this.updateOrderData.action = "assign";
                    this.updateOrderData.assigned_duration =
                        item.assigned_order_duration;
                    this.updateOrderData.booking_date = this.formatDate(
                        item.booking_date,
                        "YYYY-MM-DDTHH:mm"
                    );

                    // Prepare the order_booking_date and order_booking_time
                    this.updateOrderData.order_booking_date = this.formatDate(item.booking_date, "YYYY-MM-DD");
                    this.updateOrderData.order_booking_time = {hours: this.formatDate(item.booking_date, "HH"), minutes: this.formatDate(item.booking_date, "mm")};

                    $("#assignOrderModal").modal("show");
                }

                // Display the Quotation modal
                if (this.moveToStatus == "quotation") {
                    this.updateOrderData.order = item;
                    // this.updateOrderData.order_id = item.id;
                    // this.updateOrderData.final_amount = item.final_amount;
                    // this.updateOrderData.action = 'quotation';
                    this.quotationService.status = "quotation";
                    this.docRecieved = false;
                    this.quotationService.order_id = item.id;
                    this.quotationService.items = item.order_items;
                    this.quotationService.old_items = JSON.parse(JSON.stringify(item.order_items));
                    $("#createOrUpdateQuotation").modal({
                        backdrop: "static",
                        keyboard: false,
                    });
                    $("#createOrUpdateQuotation").modal("show");
                    return false;
                }

                // Display the update order amount modal
                if (this.moveToStatus == "completed") {
                    this.updateOrderData.order = item;
                    this.updateOrderData.order_id = item.id;
                    this.updateOrderData.final_amount = item.final_amount;
                    this.updateOrderData.action = "update_amount";
                    this.updateOrderData.status = "completed"

                    this.quotationService.items = [];
                    this.quotationService.items = item.order_items;
                    this.quotationService.old_items = JSON.parse(JSON.stringify(item.order_items));
                    /* console.log("Order Items: " + Object.keys(item.order_items).length);
                    console.log(item.order_items);
                    console.log("Quotation Items");
                    console.log(this.quotationService);
                    // Log the all service item name
                    for (let i = 0; i < this.quotationService.items.length; i++) {
                        console.log("Service Name: " + this.quotationService.items[i].service_name);
                    } */

                    this.calculateTotalAmount();

                    // Open modal for update order
                    $("#updateOrderData").modal("show");
                    return false;
                }

                if (this.moveFromStatus == "quotation" && this.moveToStatus == "declined") {
                    this.quotationService.status = "declined";
                    this.quotationService.order_id = item.id;
                    this.quotationService.items = item.order_items;
                    this.quotationService.old_items = JSON.parse(JSON.stringify(item.order_items));
                    this.docRecieved = true;
                    $("#createOrUpdateQuotation").modal({
                        backdrop: "static",
                        keyboard: false,
                    });
                    $("#createOrUpdateQuotation").modal("show");
                    return false;
                }

                //this.moveFromStatus = "";
                //this.moveToStatus = "";

                // Update the status of the order in the current object
                if (this.orders[status]) {
                    this.orders[status].find((order) => {
                        if (order.id == item.id) {
                            order.status = status;
                        }
                    });
                    //return false;
                    axios
                        .post("/admin/orders/update-status", {
                            order_id: item.id,
                            status: status,
                            comment:
                                "( Moved from " +
                                this.moveFromStatus +
                                " to " +
                                this.moveToStatus +
                                ")",
                        })
                        .then((response) => {
                            self.getOrders();
                            self.$notification(
                                response.data.status,
                                response.data.message
                            );
                        });
                }
            }

            return false;
        },
        assignOrder(action) {
            const config = {
                headers: { "content-type": "multipart/form-data" },
            };

            this.isLoading = true;
            let self = this;
            const data = this.updateOrderData;

            if(this.updateOrderData.handyman_id.length === 0) {
                self.$notification('error', "Please assign atleast one handyman to the order.");
                this.isLoading = false;
                return;
            }

            // Get the handyman name
            let names = this.updateOrderData.handyman_id.map((id) => {
                return this.handymanUsers.find(
                    (handyman) => handyman.id == id
                )?.name;
            });

            let nameString;
            if (names.length > 2) {
                // Join all but the last name with a comma, and append the last name with "and"
                nameString = `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
            } else if (names.length === 2) {
                // If exactly two names, join with "and"
                nameString = names.join(' and ');
            } else {
                // If only one name, or none, no join needed
                nameString = names.join('');
            }

            // Check if reassign handyman then prepare the comment data
            if (this.updateOrderData.action == "reassign") {
                this.updateOrderData.comment = (this.updateOrderData.comment.length > 0 ? this.updateOrderData.comment + " - " : "") + "(Reassigned to " + nameString + ")";
            }
            else {
                this.updateOrderData.comment = (this.updateOrderData.comment.length > 0 ? this.updateOrderData.comment + " - " : "") + "( Moved from " + this.moveFromStatus + " to " + this.moveToStatus + ", Assigned to " + nameString + ")";
            }

            // Push the files to the data
            if(action == "assign") {
                this.updateOrderData.files = this.$refs.assignOrderImageUploader.files.map((file) => file.file);
            }
            else {
                this.updateOrderData.files = this.$refs.reassignOrderImageUploader.files.map((file) => file.file);
            }

            axios
                .post("/admin/orders/assign", this.updateOrderData, config)
                .then((response) => {
                    if (response.data.status == "success")
                    {
                        self.getOrders();
                        self.$notification(response.data.status,response.data.message);

                        self.resetCurrentOrder();

                        self.moveFromStatus = "";
                        self.moveToStatus = "";
                        self.enggDocReady = false;
                        self.dragItemIndex = "";
                        self.dragItem = {};

                        // Trigger the event to get the unavailable handymans orders
                        self.$emitter.emit("getUnavailableHandymansOrdersEvent");

                        // Reset the image uploader
                        self.$refs.imageUploader.clearFiles();
                    }
                    else
                    {
                        self.$notification(response.data.status,response.data.message);
                    }

                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        submitBackwardMove() {
            let self = this;
            if (this.backwardReason.length === 0) {
                return (this.errors["backwardReason"] =
                    "Please provide a valid reason.");
            }
            let action = 'status_reverted';
            if(this.moveToStatus == 'pending' && this.moveFromStatus == 'quotation'){
                action = 'quotation_approved';
            }
            delete this.errors["backwardReason"];
            //alert(1)
            // API call to submit the status change and reason
            const postData = {
                order_id: this.dragItem.id, // Assuming dragItem is the order being moved
                new_status: this.moveToStatus,
                reason: this.backwardReason,
            };

            axios
                .post("/admin/orders/update-status", {
                    order_id: this.dragItem.id, // Assuming dragItem is the order being moved
                    status: this.moveToStatus,
                    action: action,
                    reason:
                        this.backwardReason +
                        " - " +
                        "( Moved from " +
                        this.moveFromStatus +
                        " to " +
                        this.moveToStatus +
                        ")",
                })
                .then((response) => {
                    self.getOrders();
                    $("#confirmBackwardMoveModal").modal("hide");

                    self.$notification(
                        response.data.status,
                        response.data.message
                    );
                });

            // Reset reason and close modal
            this.backwardReason = "";
        },
        updateOrder() {
            let action = this.updateOrderData.action || '';
            this.updateOrderData.submit_form = true;

            // Validate invoice id
            if (this.updateOrderData.invoice_number == '' && this.updateOrderData.action == "update_amount") {
                this.$notification('error', 'Please provide an invoice number.');
                return;
            }

            // Check if recurring services are enabled and not added then show error
            if(action != 'canceled' && this.displayRecurringServices && !this.$refs.recurringServices?.isServiceModified) {
                // Show confirmation alert
                if (!confirm("You have not chosen a date for recurring services. Would you like to continue or please enter a date?")) {
                    return; // Stop form submission if user selects "Cancel"
                }
            }

            // After validation again set submit_form to false
            this.updateOrderData.submit_form = false;
            this.isLoading = true;
            let self = this;
            const config = {
                headers: { "content-type": "multipart/form-data" },
            };
            const data = this.updateOrderData;
            data.services = this.quotationService.items;
            data.old_items = this.quotationService.old_items;
            data.discount = this.updateOrderData.order.discount_value;
            data.tax = this.updateOrderData.order.tax;
            if (this.updateOrderData.action == "canceled") {
                data.comment = (data.comment.length > 0 ? data.comment : "Order Canceled");
            }
            else if(data.comment.length > 0) {
                data.comment = data.comment + ` - (Moved from ${this.moveFromStatus} to ${this.moveToStatus})`;
            }
            else {
                data.comment = `Moved from ${this.moveFromStatus} to ${this.moveToStatus}`;
            }

            // Push the files to the data
            data.files = this.$refs.imageUploader.files.map((file) => file.file);

            axios
                .post("/admin/orders/update-order", data, config)
                .then((response) => {
                    self.getOrders();
                    self.$notification(
                        response.data.status,
                        response.data.message
                    );

                    self.updateOrderData.invoice_number = '';
                    self.updateOrderData.invoice_date = self.moment(new Date()).format('YYYY-MM-DD');

                    self.isLoading = false;
                    self.resetCurrentOrder();

                    // Reset the image uploader
                    self.$refs.imageUploader.clearFiles();
                });
        },
        resetCurrentOrder() {
            this.updateOrderData.order = {};
            this.updateOrderData.order_id = "";
            this.updateOrderData.final_amount = 0;
            this.updateOrderData.action = "";
            this.updateOrderData.handyman_id = "";
            this.updateOrderData.booking_date = "";
            this.updateOrderData.comment = "";
            this.updateOrderData.status = "";

            $("#assignOrderModal").modal("hide");
            $("#updateOrderData").modal("hide");

            // Hide reassign modal
            $("#reassignOrderModal").modal("hide");
            $('#cancelOrderModal').modal("hide");
        },
        formatDate(date, format) {
            return moment(date).format(format);
        },
        setMinDatetime() {
            // Set the minimum datetime
            this.minDatetime = moment().format("YYYY-MM-DDTHH:mm");
        },
        saveQuotation() {
            let self = this;
            this.isLoading = true;

            const config = {
                headers: { "content-type": "multipart/form-data" },
            };

            const data = this.quotationService;
            data.discount = this.updateOrderData.order.discount_value;
            data.tax = this.updateOrderData.order.tax;
            data.comment += (data.comment.length > 0 ? " - " : "") + "( Moved from " + this.moveFromStatus + " to " + this.moveToStatus + ")";

            // Push the files to the data
            data.files = this.$refs.quotationImageUploader.files.map((file) => file.file);

            axios
                .post("/admin/orders/update-order-quotation", data, config)
                .then((response) => {
                    self.getOrders();
                    self.$notification(
                        response.data.status,
                        response.data.message
                    );
                    self.isLoading = false;
                    self.docRecieved = false;
                    $("#createOrUpdateQuotation").modal("hide");

                    // Reset the image uploader
                    self.$refs.imageUploader.clearFiles();
                });
        },
        getServicesForOrder() {
            let self = this;
            axios
                .post("/admin/services/get-services-for-order", {})
                .then((response) => {
                    self.services = response.data.services;
                    self.packages = response.data.packages;

                    // Prepare service options
                    self.serviceOptions = [{ id: " ", text: "Select Service", name: "Select Service" }];
                    response.data.services.forEach((service) => {
                        self.serviceOptions.push({
                            id: service.id,
                            text: service?.name,
                            name: service?.name
                        });
                    });

                    // Prepare package options
                    self.packageOptions = [{ id: " ", text: "Select Package" }];
                    response.data.packages.forEach((packageItem) => {
                        self.packageOptions.push({
                            id: packageItem.id,
                            text: packageItem?.name,
                            name: packageItem?.name
                        });
                    });
                });
        },
        calculateServiceItemAmount(type, index) {
            let self = this;
            // Find the service detail based on the type and index
            let serviceDetail = {};
            if (type == "service") {
                // Get the service detail
                serviceDetail = self.services.find(
                    (service) =>
                        service.id ==
                        self.quotationService.items[index].service_id
                );
            } else if (type == "package") {
                serviceDetail = this.packages.find(
                    (servicePackage) =>
                        servicePackage.id ==
                        this.quotationService.items[index].package_id
                );
            }

            // Check if serviceDetail is not empty then update the amount in order.services
            let itemPrice = 0;
            let itemLabourCost = 0;
            if (Object.keys(serviceDetail).length > 0) {
                itemPrice = serviceDetail.price;
                itemLabourCost = serviceDetail.labour_cost;
            }

            this.quotationService.items[index].service_id = serviceDetail.id;
            this.quotationService.items[index].order_item_price = itemPrice;
            this.quotationService.items[index].order_item_labour_cost = itemLabourCost;
            this.quotationService.items[index].order_item_total_amount = itemPrice + itemLabourCost;
            this.quotationService.items[index].service_name = serviceDetail?.name;
        },
        calculateTotalAmount() {
            // Calculate total amount for all services
            let totalAmount = 0;

            this.quotationService.items.forEach((service) => {
                let itemPrice = Number(service.order_item_price) || 0;
                let itemLabourCost = Number(service.order_item_labour_cost) || 0;
                let order_item_total_amount = itemPrice + itemLabourCost;
                const discount = (order_item_total_amount * service.order_item_discount_value) / 100;
                totalAmount += order_item_total_amount - discount;
            });


            // Get the overall discount
            const discountPercentage = Number(this.updateOrderData.order.discount_value) || 0;
            const discount = (totalAmount * discountPercentage) / 100;
            const discountedAmount = totalAmount - discount;

            // Apply the 20% vat on the discounted amount
            const vat = (discountedAmount * this.updateOrderData.order.tax) / 100;
            let finalAmount = discountedAmount + vat;


            // Place only two decimal places
            finalAmount = parseFloat(finalAmount).toFixed(2);

            // Update the total amount in the order object
            this.updateOrderData.final_amount = finalAmount;
            this.updateOrderData.total_amount = totalAmount;
        },
        addMoreServiceItem() {
            // First check if quotation items are less than service items and proceed to add more
            if (this.quotationService.items.length < this.services.length) {
                this.quotationService.items.push({
                    service_id: "",
                    order_item_id: "",
                    order_item_price: "",
                    order_item_labour_cost: 0,
                    order_item_discount_type: "",
                    order_item_discount_value: 0,
                    order_item_tax: this.tax,
                    order_item_total_amount: 0,
                    order_item_sub_total_amount: 0,
                    item_type: "service",
                });
            }
        },
        removeOrderItem(index) {
            this.quotationService.items.splice(index, 1);
        },
        viewOrderDetail(order) {
            this.orderDetails = order;
            $("#viewOrderDetail").modal("show");
        },
        cancelItemDrop() {
            this.enggDocReady = false;
            this.docRecieved = false;

            const indexToDelete = this.orders[this.moveToStatus].findIndex(
                (order) => order.id === this.dragItem.id
            );
            if (indexToDelete !== -1) {
                this.orders[this.moveToStatus].splice(indexToDelete, 1);
            }

            // Move back to pending
            this.orders[this.moveFromStatus].splice(
                this.dragItemIndex,
                0,
                this.dragItem
            );

            // Hide the modal
            $("#assignOrderModal").modal("hide");
            $("#confirmBackwardMoveModal").modal("hide");
            $("#createOrUpdateQuotation").modal("hide");
        },
        truncateString(str, maxLength) {
            if (str.length > maxLength) {
                return str.substring(0, maxLength) + '...';
            }
            return str;
        },

        // Search orders by date
        searchOrders() {
            // Convert search string to lowercase
            const searchOrderLower = this.searchOrder.toLowerCase();
            let startDate = '';
            let endDate = '';
            if (this.selectedFilterDate === 'today') {
                startDate = moment().format('YYYY-MM-DD');
                endDate = moment().format('YYYY-MM-DD');
            }
            else if(this.selectedFilterDate === 'tomorrow') {
                startDate = moment().add(1, 'days').format('YYYY-MM-DD');
                endDate = moment().add(1, 'days').format('YYYY-MM-DD');
            }
            else if(this.selectedFilterDate === 'yesterday') {
                startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            }
            else if(this.selectedFilterDate === 'custom_day') {
                startDate = moment(this.currentDate).format('YYYY-MM-DD');
                endDate = moment(this.currentDate).format('YYYY-MM-DD');
            }
            else if(this.selectedFilterDate === 'this_week') {
                startDate = moment().startOf('week').format('YYYY-MM-DD');
                endDate = moment().endOf('week').format('YYYY-MM-DD');
            }
            else if(this.selectedFilterDate === 'next_week') {
                startDate = moment().add(1, 'week').startOf('week').format('YYYY-MM-DD');
                endDate = moment().add(1, 'week').endOf('week').format('YYYY-MM-DD');
            }
            else if(this.selectedFilterDate === 'custom_week') {
                startDate = moment(this.startOfWeek).format('YYYY-MM-DD');
                endDate = moment(this.endOfWeek).format('YYYY-MM-DD');
            }
            else if(this.selectedFilterDate === 'this_month') {
                startDate = moment().startOf('month').format('YYYY-MM-DD');
                endDate = moment().endOf('month').format('YYYY-MM-DD');
            }
            else if(this.selectedFilterDate === 'last_month') {
                startDate = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
                endDate = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
            }
            else if(this.selectedFilterDate === 'custom_month') {
                startDate = moment(this.currentMonth).startOf('month').format('YYYY-MM-DD');
                endDate = moment(this.currentMonth).endOf('month').format('YYYY-MM-DD');
            }
            else if(this.selectedFilterDate === 'this_year') {
                startDate = moment().startOf('year').format('YYYY-MM-DD');
                endDate = moment().endOf('year').format('YYYY-MM-DD');
            }
            else {
                startDate = '';
                endDate = '';
            }

            // Check if search string and search date is not empty
            if (searchOrderLower.trim() !== '' || startDate !== '') {
                // Reset orders from originalOrders before filtering
                this.orders = JSON.parse(JSON.stringify(this.allOrders));

                // Filter the order
                Object.keys(this.orders).forEach(key => {
                    this.orders[key] = this.orders[key].filter((order) => {
                        // Check if search string is not empty and search date is not empty
                        if (searchOrderLower.trim() !== '' && startDate !== '') {
                            // Get the handyman name
                            let handymanName = '';
                            order.order_handymans.forEach((e) => {
                                handymanName = ',' + e.handyman?.name.toLowerCase(); // Convert to lowercase
                            });

                            let orderDate = this.formatDate(order.booking_date, 'YYYY-MM-DD');
                            // Filter the order
                            return ((order.booking_address.toLowerCase().search(searchOrderLower) !== -1 ||
                                    order.order_number.toLowerCase().search(searchOrderLower) !== -1 ||
                                    order.postal_code.toLowerCase().search(searchOrderLower) !== -1 ||
                                    handymanName.toLowerCase().search(searchOrderLower) !== -1 ||
                                    this.formatDate(order.booking_date,"DD-MMM-YYYY").toLowerCase().search(searchOrderLower) !== -1 ||
                                    order.full_name.toLowerCase().search(searchOrderLower) !== -1) &&
                                (orderDate >= startDate && orderDate <= endDate));
                        }
                        else if(searchOrderLower.trim() !== '') {
                            // Get the handyman name
                            let handymanName = '';
                            order.order_handymans.forEach((e) => {
                                handymanName = ',' + e.handyman?.name.toLowerCase(); // Convert to lowercase
                            });
                            // Filter the order
                            return (order.booking_address.toLowerCase().search(searchOrderLower) !== -1 ||
                                    order.order_number.toLowerCase().search(searchOrderLower) !== -1 ||
                                    order.postal_code.toLowerCase().search(searchOrderLower) !== -1 ||
                                    handymanName.toLowerCase().search(searchOrderLower) !== -1 ||
                                    this.formatDate(order.booking_date,"DD-MMM-YYYY").toLowerCase().search(searchOrderLower) !== -1 ||
                                    order.full_name.toLowerCase().search(searchOrderLower) !== -1
                                );
                        }
                        else if(startDate !== '') {
                            let orderDate = this.formatDate(order.booking_date, 'YYYY-MM-DD');
                            return orderDate >= startDate && orderDate <= endDate;
                        }
                    });
                });
            }
            else {
                // Reset orders
                this.orders = JSON.parse(JSON.stringify(this.allOrders));
            }

            // Regenerate map
            this.initMap();
        },
        resetOrderFilter() {
            this.searchOrder = '';
            this.selectedFilterDate = '';
        },
        /* getHandymanSchedules() {
            let self = this;
            axios.post("/admin/handymans/get-hm-schedules")
                .then((response) => {
                    self.handymanSchedules = response.data.schedules;
                });
        }, */

        // Prepare handyman options from the schedules
        prepareHandymanOptions() {
            let self = this;
            self.handymanOptions = [];

            const dateToFind = this.formatDate(this.updateOrderData.booking_date, 'YYYY-MM-DD');
            const timeToFind =  moment(this.updateOrderData.booking_date, 'YYYY-MM-DD HH:mm:ss');

            Object.keys(this.handymanSchedules).forEach((handymanId) => {
                this.handymanSchedules[handymanId].forEach((schedule) => {
                    const startTime = moment(`${schedule.schedule_date} ${schedule.start_time}`, 'YYYY-MM-DD HH:mm:ss');
                    const endTime = moment(`${schedule.schedule_date} ${schedule.end_time}`, 'YYYY-MM-DD HH:mm:ss');
                    if (schedule.schedule_date === dateToFind && timeToFind.isBetween(startTime, endTime,undefined, '[]')) {
                        let exists = self.handymanOptions.some(function(option) {
                            return option.id === schedule.handyman_id;
                        });
                        // If it doesn't exist, push the new option
                        if (!exists) {
                            self.handymanOptions.push({
                                id: schedule.handyman_id,
                                text: schedule.full_name + ' (' + moment(schedule.start_time, 'HH:mm:ss').format('hh:mm A') + ' - ' + moment(schedule.end_time, 'HH:mm:ss').format('hh:mm A') + ')',
                                name: schedule.full_name + ' (' + moment(schedule.start_time, 'HH:mm:ss').format('hh:mm A') + ' - ' + moment(schedule.end_time, 'HH:mm:ss').format('hh:mm A') + ')',
                            });
                            self.isHandymanAvailable = true;
                        }
                    }
                });
            });

            // Check if handyman is available
            if(Object.keys(self.handymanOptions).length > 1) {
                self.isHandymanAvailable = true;
            }
            else {
                self.isHandymanAvailable = false;
            }
        },
        // Prepare Order Booking Date picker options
        prepareBookingDatePickerOptions() {
            let self = this;
            //allowedBookingDates
            const availableDates = [];
            Object.keys(this.handymanSchedules).forEach((handymanId) => {
                this.handymanSchedules[handymanId].forEach((schedule) => {
                    availableDates.push(schedule.schedule_date);
                });
            });

            this.allowedBookingDates = [...new Set(availableDates)];
        },

        // Open reassign modal popup
        //openReassignModal(order) {
        //    this.updateOrderData.order = order;
        //    this.updateOrderData.order_id = order.id;
        //    this.updateOrderData.status = 'assigned';
        //    this.updateOrderData.action = "reassign";
        //    this.updateOrderData.booking_date = order.booking_date;
        //    this.updateOrderData.assigned_duration = order.assigned_order_duration;
        //
        //    // Display selected handymans
        //    this.updateOrderData.handyman_id = [];
        //    // Iterate the order handymans
        //    order.order_handymans.forEach((element) => {
        //        this.updateOrderData.handyman_id.push(element.handyman_id);
        //    });
        //
        //    // Display the modal
        //    $('#reassignOrderModal').modal('show');
        //},
        formattedDate(date, format) {
            return moment(date).format(format);
        },
        getNextData() {
            if (this.daysOptions.includes(this.selectedFilterDate)) {
                this.selectedFilterDate = 'custom_day';
            }
            else if (this.weekOptions.includes(this.selectedFilterDate)) {
                this.selectedFilterDate = 'custom_week';
            }
            else if (this.monthOptions.includes(this.selectedFilterDate)) {
                this.selectedFilterDate = 'custom_month';
            }
            // Check if display type is day then add 1 day
            if(this.daysOptions.includes(this.selectedFilterDate)) {
                this.currentDate = moment(this.currentDate).add(1, 'days').format('DD MMM YYYY');
            }
            else if (this.weekOptions.includes(this.selectedFilterDate)) {
                this.startOfWeek = moment(this.startOfWeek).add(1, "weeks");
                this.endOfWeek = moment(this.endOfWeek).add(1, "weeks");
            }
            else if (this.monthOptions.includes(this.selectedFilterDate)) {
                this.currentMonth = moment(this.currentMonth).add(1, "months");
            }

            this.searchOrders();
        },
        getPreviousData() {
            if (this.daysOptions.includes(this.selectedFilterDate)) {
                this.selectedFilterDate = 'custom_day';
            }
            else if (this.weekOptions.includes(this.selectedFilterDate)) {
                this.selectedFilterDate = 'custom_week';
            }
            else if (this.monthOptions.includes(this.selectedFilterDate)) {
                this.selectedFilterDate = 'custom_month';
            }
            // Check if display type is day then subtract 1 day
            if(this.daysOptions.includes(this.selectedFilterDate)) {
                this.currentDate = moment(this.currentDate).subtract(1, 'days').format('DD MMM YYYY');
            }
            else if (this.weekOptions.includes(this.selectedFilterDate)) {
                this.startOfWeek = moment(this.startOfWeek).subtract(1, "weeks");
                this.endOfWeek = moment(this.endOfWeek).subtract(1, "weeks");
            }
            else if (this.monthOptions.includes(this.selectedFilterDate)) {
                this.currentMonth = moment(this.currentMonth).subtract(1, "months");
            }

            this.searchOrders();
        },
        initMap() {
            // iterate over the assigned orders and processing orders
            this.mapOrders = [];
            Object.keys(this.orders).forEach(key => {
                // Check if key is assigned or processing
                // then iterate and push to markers
                if (['assigned', 'processing'].includes(key)) {
                    this.orders[key].forEach((order, index) => {
                        this.mapOrders.push(order);
                    });
                }
            });
        },
        autoOpenAssignModal(params) {
            this.moveFromStatus = params.moveFromStatus;
            this.moveToStatus = params.moveToStatus;
            this.dragItem = params.item;
            const indexToDelete = this.orders[
                this.moveFromStatus
            ].findIndex((order) => order.id === this.dragItem.id);
            if (indexToDelete !== -1) {
                this.orders[this.moveFromStatus].splice(indexToDelete, 1);
            }
            //move to destination bucket
            this.orders[this.moveToStatus].splice(0, 0, this.dragItem);
            this.onChangeItem({
                added: {
                    element: params.item,
                },
            });
        },
        openCreateOrderWindow() {
            // Open in the same tab
            window.location.href = '/admin/orders/create';
            return;
            // Open documentation in new tab
            const newTab = window.open('/admin/orders/create');

            if (!newTab) {
                return;
            }

            // Check if tab is closed every second
            const tabChecker = setInterval(() => {
                if (newTab.closed) {
                    clearInterval(tabChecker);

                    // Optional: focus back on original window
                    window.focus();

                    // Perform any other actions needed
                    this.onTabClosed();
                }
            }, 1000);
        },
        onTabClosed() {
            // Perform any actions needed when the tab is closed
            this.getOrders();
        },
        approveTemporaryOrder(order) {
            window.Swal.fire({
                title: 'Are you sure?',
                text: "Are you sure you want to approve this temporary order?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, approve it!',
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.post('/admin/orders/approve', {
                        order_id: order.id
                    }).then((response) => {
                        let data = response.data;

                        if(data.status === 'success') {
                            order.is_approved = 1;
                        }

                        if(data.action === 'refresh_orders') {
                            this.getOrders();
                        }

                        this.$notification(data.status, data.message);
                    }).catch((error) => {
                        let message = error.response.data.message;
                        this.$notification('error', message);
                    });
                }
            });
        },
        updateMobileState() {
            this.$forceUpdate(); // Refresh component when screen resizes
        },
        handleTouchStart(e, order) {
            this.touchStartX = e.touches[0].clientX
            this.touchStartY = e.touches[0].clientY
            this.isTouchMoving = false

            // Start timer for long press
            this.touchTimer = setTimeout(() => {
                if (!this.isTouchMoving) {
                    this.showTouchMenu(e, order);
                }
            }, 500) // 500ms delay for long press
        },
        handleTouchEnd() {
            clearTimeout(this.touchTimer)
        },
        handleTouchMove(e) {
            // Check if finger moved significantly
            const moveX = Math.abs(e.touches[0].clientX - this.touchStartX)
            const moveY = Math.abs(e.touches[0].clientY - this.touchStartY)

            if (moveX > 10 || moveY > 10) {
                this.isTouchMoving = true
            }
        },
        showTouchMenu(e, order) {
            // Create a synthetic mouse event for the context menu
            const syntheticEvent = {
                clientX: e.touches[0].clientX,
                clientY: e.touches[0].clientY,
                preventDefault: () => {},
                stopPropagation: () => {}
            }

            this.orderItemClick(e, order);

            // Prevent default touch behavior
            e.preventDefault()
        },
        async getHandymanAvailable() {
            //First check if processing then return
            if (this.processing) return;
            this.processing = true;

            // Prepare start and end time
            let params = {
                order_id: this.updateOrderData.order_id,
                booking_date: this.updateOrderData.order_booking_date,
                start_time: this.updateOrderData.order_booking_time,
                end_time: {
                    hours: this.padZero(parseInt(this.updateOrderData.order_booking_time.hours) + this.updateOrderData.assigned_duration),
                    minutes: this.updateOrderData.order_booking_time.minutes
                },
            };
            let users = await this.getHandymanForTaskAssignment(params);

            //Check if user is empty then empty the handyman_ids
            if (users?.length == 0) {
                this.updateOrderData.handyman_id = [];
            }
            //Prepare the options
            this.handymanList = users?.map(user => ({
                id: user.id,
                text: user.name,
                name: user.name,
                email: user.email,
                temporary_booked: user.temporary_booked,
            }));

            this.processing = false;
        },
        onSelectHandyman(event) {
            // Check if temporary_booked is true then show alert
            if (event.temporary_booked) {
                Swal.fire({
                    text: `${event.name} is temporary booked for another task, are you sure you want to assign this task to ${event.name}?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, assign it!',
                    reverseButtons: true
                }).then((result) => {
                    if (!result.isConfirmed) {
                        // Then remove the id from the updateOrderData.handyman_id
                        this.updateOrderData.handyman_id = this.updateOrderData.handyman_id.filter(id => id !== event.id);
                    }
                });
            }
        },
        isOrderTypeLoading(status) {
            switch(status) {
                case 'pending': return this.isPendingLoading;
                case 'assigned': return this.isAssignedLoading;
                case 'processing': return this.isProcessingLoading;
                case 'quotation': return this.isQuotationLoading;
                case 'completed': return this.isCompletedLoading;
                case 'declined': return this.isDeclinedLoading;
                case 'engineer_completed': return this.isEngineerCompletedLoading;
                default: return false;
            }
        },
        handleSetupRecurringServices() {
            if (this.setupRecurringServices) {
                this.$refs.setupRecurringServices.openModal();
            }
        },
        handleRecurringServicesLoaded(services) {
            this.visibleRecurringServices = services;
        },
        getRecurringSummary(services) {
            if(this.$refs.setupRecurringServices) {
                console.log("Services fetched in parent:", services);
                this.scheduledServices = services;
                // console.log("Get recurring summary");
                // console.log(this.$refs.setupRecurringServices.recurringServicesSummary);
                // return this.$refs.setupRecurringServices.recurringServicesSummary;
            }
            //return [];
        }
    },
    watch: {
        "quotationService.items": {
            handler(newServices, oldServices) {
                // Recalculate the total amount and total discount for all services
                this.calculateTotalAmount();
            },
            deep: true,
        },
        "updateOrderData.order.tax": {
            handler(newServices, oldServices) {
                // Recalculate the total amount and total discount for all services
                this.calculateTotalAmount();
            },
            deep: true,
        },
        "updateOrderData.order.discount_value": {
            handler(newServices, oldServices) {
                // Recalculate the total amount and total discount for all services
                this.calculateTotalAmount();
            },
            deep: true,
        },
        'updateOrderData.booking_date': function(newVal, oldVal) {
            this.prepareHandymanOptions();
            this.getHandymanAvailable();
        },
        'updateOrderData.order_booking_date': function(newVal, oldVal) {
            this.updateOrderData.booking_date = this.formatDate(this.updateOrderData.order_booking_date, 'YYYY-MM-DD') + ' ' + this.updateOrderData.order_booking_time.hours + ':' + this.updateOrderData.order_booking_time.minutes + ':00';
            this.getHandymanAvailable();
        },
        'updateOrderData.order_booking_time': function(newVal, oldVal) {
            this.updateOrderData.booking_date = this.formatDate(this.updateOrderData.order_booking_date, 'YYYY-MM-DD') + ' ' + this.updateOrderData.order_booking_time.hours + ':' + this.updateOrderData.order_booking_time.minutes + ':00';
            this.getHandymanAvailable();
        },
        "searchOrder":{
            handler(newServices, oldServices) {
                // Recalculate the total amount and total discount for all services
                this.searchOrders();
            },
        },
        selectedFilterDate() {
            this.searchOrders();
        },
        handymanSchedules: {
            handler(newServices, oldServices) {
                this.prepareBookingDatePickerOptions();
            },
            deep: true,
        },
        'updateOrderData.assigned_duration_type': function (newVal, oldVal) {
            if (newVal === "full_day") {
                this.updateOrderData.assigned_duration = 8;
            }
        }
    },
};
</script>
<style scoped>
.flip-list-move {
    transition: transform 0.5s;
}

.no-move {
    transition: transform 0s;
}

.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}
.order-list-group-item {
    cursor: move;
}
</style>
<style>
.select2-container--default
    .select2-selection--multiple
    .select2-selection__rendered {
    position: absolute;
    top: 0;
}
.select2-container--default
    .select2-selection--multiple
    .select2-selection__choice__display {
    padding-left: 20px;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type="number"] {
    -moz-appearance: textfield;
}
.item-fields-number {
    width: 13% !important;
}
.item-fields-number input {
    padding-left: 5px;
    padding-right: 5px;
}
</style>
